<template>
  <!-- field.ext2 这个值用来表示是不是级联字段，等于1时表示默认不显示，需要通过级联处理才显示 -->
  <!-- -casDefautShow 这个值用来表示级联字段被选中状态，是已经输入过数据，需要保存-->
    <div v-if="isView && (field.ext2 !== '1' || formData[field.id + '-casDefautShow']) && field.options.description.indexOf('$hideField$') === -1" :style="activeStyle()" :class="(this.field.type === 'user'&& selectedUser.pageData.length > 0) ? 'render-form-item user-item-detail':'render-form-item'">
  <!-- <li :style="activeStyle()"> -->
    <!-- <div class="com render-form-item"> -->
        <el-row>
            <!-- <el-col v-if="field.ext2 !== '1' || formData[field.id + '-casDefautShow']" :span="isPrintPage || this.field.type === 'subform' || this.field.type === 'archive' || this.isFromSubForm ? 24 : 22"> -->
            <el-col :span="isPrintPage || this.field.type === 'subform' || this.field.type === 'archive' || this.isFromSubForm ? 24 : 22">
                <!-- <el-col :span='24'> -->
                <template v-if="field.type === 'text'">
                    <el-row>
                        <el-col v-if="field.options.ext1 != undefined" :span="16">
                            <el-form-item
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]"
                            >
                                <template v-if="fieldSubType === 'input'">
                                    <el-input v-if="!field.options.autoComplete" style="width:100%" :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))" v-model="formField" />
                                    <el-autocomplete
                                        v-if="field.options.autoComplete"
                                        style="width:100%" 
                                        :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))"
                                        v-model="formField"
                                        :fetch-suggestions="querySearchAsync"
                                        placeholder="请输入内容"
                                        :trigger-on-focus="false"
                                        @select="handleTextSelect">
                                    </el-autocomplete>
                                </template>    
                                <el-tooltip v-bind:content="formField" placement="bottom" effect="light" :disabled="!formField" popper-class="field-tips">
                                    <el-input
                                          :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))"
                                          :class="approvalRemarksStyle"
                                          :placeholder="placeholderContent"
                                          v-if="fieldSubType === 'textarea'"
                                          type="textarea"
                                          :autosize="{ minRows: 2, maxRows: 2 }"
                                          v-model="formField"
                                      />
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField">
                                <template v-if="fieldSubType === 'input'">
                                    <el-input v-if="!field.options.autoComplete" style="width:100%" :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))" v-model="formField" />
                                    <el-autocomplete
                                        v-if="field.options.autoComplete"
                                        style="width:100%" 
                                        :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))"
                                        v-model="formField"
                                        :fetch-suggestions="querySearchAsync"
                                        placeholder="请输入内容"
                                        :trigger-on-focus="false"
                                        @select="handleTextSelect">
                                    </el-autocomplete>
                                </template>    
                                <el-tooltip v-bind:content="formField" placement="bottom" effect="light" :disabled="!formField" popper-class="field-tips">
                                    <!-- :autosize="{ minRows: 1, maxRows: 2}" -->
                                    <el-input
                                        :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))"
                                        :class="approvalRemarksStyle"
                                        :placeholder="placeholderContent"
                                        v-if="fieldSubType === 'textarea'"
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 2 }"
                                        v-model="formField"
                                    />
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                        <el-col v-else :span="24">
                            <el-form-item
                                class="item-textarea"
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]"
                            >
                                <template v-if="fieldSubType === 'input'">
                                    <el-input v-if="!field.options.autoComplete" :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))" v-model="formField" />
                                    <el-autocomplete
                                        v-if="field.options.autoComplete"
                                        style="width:100%" 
                                        :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))"
                                        v-model="formField"
                                        :fetch-suggestions="querySearchAsync"
                                        placeholder="请输入内容"
                                        :trigger-on-focus="false"
                                        @select="handleTextSelect">
                                    </el-autocomplete>
                                </template>    
                                
                                <template v-if="field.options.ext3 && field.options.ext3 ==='1' "> 
                                    <Editorbar  ref="editorbarRef" :formData="formData" :field="field" v-model="formField" :value="editorbarVal" :isShowClick="false"></Editorbar>
                                </template> 
                                <template v-else>    
                                  <el-tooltip v-bind:content="formField" placement="bottom" effect="light" :disabled="!formField"  popper-class="field-tips"></el-tooltip>
                                    <el-input
                                          :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))"
                                          :class="approvalRemarksStyle"
                                          :placeholder="placeholderContent"
                                          v-if="fieldSubType === 'textarea'"
                                          type="textarea"
                                          :autosize="{ minRows: 2, maxRows: 2 }"
                                          v-model="formField"
                                      />
                                  </el-tooltip>
                                </template>
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField" class="item-textarea">
                                <template v-if="fieldSubType === 'input'">
                                    <el-input v-if="!field.options.autoComplete" :disabled="isReadOnly(field) ||(isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))" v-model="formField"/>
                                    <el-autocomplete
                                        v-if="field.options.autoComplete"
                                        style="width:100%" 
                                        :disabled="isReadOnly(field) || (isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField))"
                                        v-model="formField"
                                        :fetch-suggestions="querySearchAsync"
                                        placeholder="请输入内容"
                                        :trigger-on-focus="false"
                                        @select="handleTextSelect">
                                    </el-autocomplete>
                                </template>    
                               
                                    <!-- :autosize="{ minRows: 1, maxRows: 2}" -->
                                    <template v-if="field.options.ext3 && field.options.ext3 ==='1' ">
                                      <!-- <div class="richtext-content">
                                         <p v-html="formField"></p>
                                     </div> -->
                                     <Editorbar  ref="editorbarRef" :formData="formData" :field="field" v-model="formField" :value="editorbarVal" :isShowClick="false"></Editorbar>
                                   </template>
                                   <template v-else> 
                                      <el-tooltip v-bind:content="formField" placement="bottom" effect="light" :disabled="!formField" popper-class="field-tips">
                                        <el-input
                                            :disabled="isReadOnly(field) || isRead || (field.options.synLinkField && ''!==field.options.synLinkField) || (field.options.upMoneyField && ''!==field.options.upMoneyField)"
                                            :class="approvalRemarksStyle"
                                            :placeholder="placeholderContent"
                                            v-if="fieldSubType === 'textarea'"
                                            type="textarea"
                                            :autosize="{ minRows: 2, maxRows: 2 }"
                                            v-model="formField"
                                        />
                                    </el-tooltip>
                                  </template>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="field.options.ext1" :span="6">
                            <el-tooltip content="请输入合法的以(http,https)等开头的网络地址" placement="top" effect="light" popper-class="field-tips">
                                <el-input style="width:100%"
                                    :rules="[{ required: true, message: '请输入' + field.name+'的链接地址', trigger: 'blur' }]" :disabled="isReadOnly(field,true) || isRead"
                                    :placeholder="field.name + '的链接地址'" v-if="field.options.ext1" v-model="ext1" @change="buildExt1" @blur="checkExt1"/>
                            </el-tooltip>
                        </el-col>
                        <el-col v-if="field.options.ext1" :span="2">
                            <el-tooltip content="跳转" placement="top" effect="light"  popper-class="field-tips">
                                <i class="el-icon-share" style="cursor: pointer;font-size: 20px;margin-top: 10px;" @click="jumpLinks(ext1)"></i>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                </template>
                <template v-if="field.type === 'number'">
                    <el-row>
                        <el-col v-if="field.options.unit" :span="20">
                            <el-form-item
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]"
                            >
                                <el-input
                                    :ref="field.id"
                                    :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"
                                    :type="numberType"
                                    @blur="calculationBlur(formField)" 
                                    @focus="calculationFocus(formField)"
                                    @mousewheel.native.prevent 
                                    v-if="fieldSubType === 'number' && !showMoneyText && !field.options.isProgress"
                                    v-model="formField"
                                />
                                <template v-if="fieldSubType === 'number' && field.options.isProgress"> 
                                  <!-- <el-progress :text-inside="true" v-if="progressStatus" style="margin-top:8px" :stroke-width="20" :status="progressStatus" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress>
                                  <el-progress :text-inside="true" v-else style="margin-top:8px" :stroke-width="20" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress> -->
                                  <ProcessSlider ref="processSliderRef" :formData="formData"   :field="field"  :fieldsList="fieldsList" :formField="field.formField" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"  :min=0 :max=100 v-model="formField"></ProcessSlider>
                                </template>
                                <!-- onkeypress="return (/[\d.-]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" -->
                                <el-input style="width:100%" :disabled="isRead || isSynLinkField || field.options.crossCountFlag" v-if="showMoneyText" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField">
                                <el-input
                                    :ref="field.id"
                                    :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"
                                    :type="numberType"
                                    @blur="calculationBlur(formField)" 
                                    @focus="calculationFocus(formField)" 
                                    @mousewheel.native.prevent 
                                    v-if="fieldSubType === 'number' && !showMoneyText && !field.options.isProgress"
                                    v-model="formField"
                                />
                                <template v-if="fieldSubType === 'number' && field.options.isProgress">
                                  <!-- <el-progress :text-inside="true" v-if="progressStatus" style="margin-top:8px" :stroke-width="20" :status="progressStatus" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress>
                                  <el-progress :text-inside="true" v-else style="margin-top:8px" :stroke-width="20" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress> -->
                                  <ProcessSlider ref="processSliderRef" :formData="formData"   :field="field"  :fieldsList="fieldsList" :formField="field.formField" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"  :min=0 :max=100 v-model="formField"></ProcessSlider>
                                </template>
                                <el-input style="width:100%" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" v-if="showMoneyText" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                        </el-col>
                        <el-col v-else :span="24">
                            <el-form-item
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]"
                            >
                                <el-input
                                    :ref="field.id"
                                    :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"
                                    :type="numberType"
                                    @blur="calculationBlur(formField)"
                                    @focus="calculationFocus(formField)" 
                                    @mousewheel.native.prevent  
                                    v-if="fieldSubType === 'number' && !showMoneyText  && !field.options.isProgress"
                                    v-model="formField"
                                />
                                <template v-if="fieldSubType === 'number' && field.options.isProgress">
                                  <!-- <el-progress :text-inside="true" v-if="progressStatus" style="margin-top:8px" :stroke-width="20" :status="progressStatus" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress>
                                  <el-progress :text-inside="true" v-else style="margin-top:8px" :stroke-width="20" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress> -->
                                  <ProcessSlider ref="processSliderRef" :formData="formData"   :field="field"  :fieldsList="fieldsList" :formField="field.formField" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"  :min=0 :max=100 v-model="formField"></ProcessSlider>
                                </template>
                                <el-input style="width:100%" :disabled="isRead || isSynLinkField || field.options.crossCountFlag" v-if="showMoneyText" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField">
                                <el-input
                                    :ref="field.id"
                                    :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"
                                    :type="numberType"
                                    @blur="calculationBlur(formField)"
                                    @focus="calculationFocus(formField)" 
                                    @mousewheel.native.prevent  
                                    v-if="fieldSubType === 'number' && !showMoneyText  && !field.options.isProgress"
                                    v-model="formField"
                                />
                                <template v-if="fieldSubType === 'number' && field.options.isProgress">
                                  <!-- <el-progress :text-inside="true" v-if="progressStatus"  style="margin-top:8px" :stroke-width="20" :status="progressStatus" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress>
                                  <el-progress :text-inside="true" v-else style="margin-top:8px" :stroke-width="20" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" :percentage="formField?formField:0"></el-progress> -->
                                  <ProcessSlider ref="processSliderRef" :formData="formData"   :field="field"  :fieldsList="fieldsList" :formField="field.formField" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag"  :min=0 :max=100 v-model="formField"></ProcessSlider>
                                </template>
                                <el-input style="width:100%" :disabled="isReadOnly(field) || isRead || isSynLinkField || field.options.crossCountFlag" v-if="showMoneyText" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="field.options.unit" :span="4">
                            <em class="numberUnit">
                            {{ field.options.unit }}
                            </em>
                        </el-col>
                    </el-row>
                </template>
                <template v-if="field.type === 'calculation'">
                    <el-row v-if="isSaveCompute || field.options.formulaExp != undefined && ((field.options.formulaExp.indexOf(';') !== -1)||(field.options.formulaExp.indexOf(',')!== -1))">
                        <el-col :span="24">
                            <el-form-item  :label="field.name" :prop="field.formField">
                              <template v-if="!this.formData.hasOwnProperty('id')">
                                  <el-tag   v-if="formField" type="danger" >{{ formField }}</el-tag>
                                  <el-tag   v-else-if="field.options.defaultValue" type="danger" >{{ field.options.defaultValue }}</el-tag>
                                  <el-tag   v-else type="info" > 保存数据时根据规则计算 </el-tag> 
                              </template>
                               <template v-else>
                                  {{formField ? formField : 0 }}&nbsp;&nbsp;<template  v-if="field.options.unit">{{ field.options.unit }}</template>
                              </template>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-else>
                        <el-col v-if="field.options.unit" :span="18">
                            <el-form-item
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]"
                            >
                                <el-input :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="!showMoneyText" :type="numberType" @blur="calculationBlur(formField)" @focus="calculationFocus(formField)" v-model="formField" />
                                <el-input style="width:100%" :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="showMoneyText" :type="numberType" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField">
                                <el-input :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="!showMoneyText" :type="numberType" @blur="calculationBlur(formField)" @focus="calculationFocus(formField)" v-model="formField" />
                                <el-input style="width:100%" :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="showMoneyText" :type="numberType" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                        </el-col>
                        <el-col v-else :span="24">
                            <el-form-item
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]"
                            >
                                <el-input :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="!showMoneyText" :type="numberType" @blur="calculationBlur(formField)" @focus="calculationFocus(formField)" v-model="formField" />
                                <el-input style="width:100%" :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="showMoneyText" :type="numberType" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField">
                                <el-input :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="!showMoneyText" :type="numberType" @blur="calculationBlur(formField)" @focus="calculationFocus(formField)" v-model="formField" />
                                <el-input style="width:100%" :disabled="isReadOnly(field) || isRead || isSynLinkField" v-if="showMoneyText" :type="numberType" v-bind:value="formField | moneyFomater" @focus="moneyTextInputFocus"/>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="field.options.unit" :span="6">
                            <em class="numberUnit numberUnit2">{{ field.options.unit }}</em>
                        </el-col>
                    </el-row>
                </template>

                <template v-if="field.type === 'subFormSummary'">
                    <el-row>
                        <el-col v-if="field.options.unit" :span="18">
                            <el-form-item :label="field.name" :prop="field.formField"  v-if="field.options.required" :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]">
                                <el-input :disabled="isReadOnly(field) || isRead" type="number" @blur="calculationBlur(formField)" v-model="formField" />
                            </el-form-item>
                            <el-form-item :label="field.name" :prop="field.formField"  v-else>
                                <el-input :disabled="isReadOnly(field) || isRead" type="number" @blur="calculationBlur(formField)" v-model="formField" />
                            </el-form-item>
                        </el-col>
                        <el-col v-else :span="22">
                            <el-form-item :label="field.name" :prop="field.formField" v-if="field.options.required" :rules="[{ required: true, message: '请输入' + field.name, trigger: 'blur' }]">
                                <el-input :disabled="isReadOnly(field) || isRead" type="number"   @blur="calculationBlur(formField)" v-model="formField" />
                            </el-form-item>
                            <el-form-item :label="field.name" :prop="field.formField" v-else>
                                <el-input :disabled="isReadOnly(field) || isRead" type="number"   @blur="calculationBlur(formField)" v-model="formField" />
                            </el-form-item>
                        </el-col>
                        <el-col v-if="field.options.unit" :span="2">
                            <em class="numberUnit numberUnit2">{{ field.options.unit }}</em>
                        </el-col>
                        <el-col v-if="!isPrintPage" :span="2">
                            <el-button type="primary" :disabled="isReadOnly(field) || isRead" style="margin: 5px;" @click="handleSubFormSummary(field)">统计</el-button>
                        </el-col>
                    </el-row>
                </template>

                <template v-if="field.type === 'date' && field.options.config.type !== 'daterange'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ type: 'string', required: true, message: '请输入' + field.name, trigger: 'change' }]"
                    >
                      <el-tooltip :disabled="isReadOnly(field) || !formField" v-bind:content="formField"  effect="light" placement="top" popper-class="field-tips">
                          <el-date-picker 
                              :editable="true"
                              :disabled="isReadOnly(field) || isRead"
                              v-if="fieldSubType === 'date'"
                              :type="dateType"
                              v-model="formField"
                              :format="dateValueformat"
                              :value-format="dateValueformat"
                              placeholder="选择日期"
                              style="width: 100%;"
                          ></el-date-picker>
                      </el-tooltip>
                      <el-tooltip :disabled="isReadOnly(field) || !formField" v-bind:content="formField"  effect="light" placement="top" popper-class="field-tips">
                        <el-date-picker
                            :editable="true"
                            :disabled="isReadOnly(field) || isRead"
                            v-if="fieldSubType === 'dateTime'"
                            :type="dateType"
                            v-model="formField"
                            :value-format="dateTimeValueformat"
                            :default-value = 'defaultTime'
                            placeholder="选择日期"
                            style="width: 100%;"
                        ></el-date-picker>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                      <el-tooltip :disabled="isReadOnly(field) || !formField" v-bind:content="formField"  effect="light" placement="top" popper-class="field-tips">
                        <el-date-picker
                            :disabled="isReadOnly(field) || isRead"
                            v-if="fieldSubType === 'date'"
                            :type="dateType"
                            v-model="formField"
                            :format="dateValueformat"
                            :value-format="dateValueformat"
                            :editable="true"
                            placeholder="选择日期"
                            style="width: 100%;"
                        ></el-date-picker>
                      </el-tooltip>
                      <el-tooltip :disabled="isReadOnly(field) || !formField" v-bind:content="formField"  effect="light" placement="top" popper-class="field-tips">
                        <el-date-picker
                            :disabled="isReadOnly(field) || isRead"
                            v-if="fieldSubType === 'dateTime'"
                            :type="dateType"
                            v-model="formField"
                            :value-format="dateTimeValueformat"
                            :editable="true"
                            :default-value = 'defaultTime'
                            placeholder="选择日期"
                            style="width: 100%;"
                        ></el-date-picker>
                      </el-tooltip>
                    </el-form-item>
                </template>
                <template v-if="field.type === 'date' && field.options.config.type === 'daterange'">
                     <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ type: 'array', required: true, message: '请输入' + field.name, trigger: 'change' }]"
                    >
                      <el-tooltip :disabled="isReadOnly(field) || !formField"   effect="light" placement="top" popper-class="field-tips">
                        <el-date-picker
                            :disabled="isReadOnly(field) || isRead"
                            :value-format="dateValueformat"
                            :editable="true"
                            v-model="formField"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            >
                        </el-date-picker>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                      <el-tooltip :disabled="isReadOnly(field) || !formField"  effect="light" placement="top" popper-class="field-tips">
                        <el-date-picker
                            :disabled="isReadOnly(field) || isRead"
                            :value-format="dateValueformat"
                            :editable="true"
                            v-model="formField"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            >
                        </el-date-picker>
                    </el-tooltip>
                    </el-form-item>
                </template>
                <template v-if="field.type === 'category'">
                    <template v-if="fieldSubType === 'single'">
                        <!-- 用于打印html页面是element样式丢失的问题 -->
                        <div v-if="isPrintPage" key="printPage">
                            <el-form-item :label="field.name" :prop="field.formField">
                                <label class="print-page-label" v-for="(item, index) in field.options.config.options" :key="index">
                                    <input type="radio" :checked="item.value === formField" disabled />
                                    {{ item.title }}
                                </label>
                            </el-form-item>
                        </div>
                        <div v-else key="printPage">
                            <el-form-item
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                            >
                                <el-radio-group v-model="formField" @change="handelRadioVal" :disabled="isReadOnly(field)">
                                    <template v-if="field.options.ext3 && field.options.ext3==='1'" >
                                        <el-radio :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState)" v-for="(item, index) in field.options.config.options" :key="index" :label="item.value"><span :style="setRadioStyle(item)" >{{ item.title }}</span></el-radio>
                                    </template>
                                    <template v-else >
                                        <el-radio-button :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState)" v-for="(item, index) in field.options.config.options" :key="index" :label="item.value"><span :style="setRadioStyle(item)" >{{ item.title }}</span></el-radio-button>
                                    </template>
                                </el-radio-group> 
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField">
                                <el-radio-group v-model="formField" @change="handelRadioVal" :disabled="isReadOnly(field)">
                                  <template  v-if="field.options.ext3 && field.options.ext3==='1'" >
                                      <el-radio :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState)" v-for="(item, index) in field.options.config.options" :key="index" :label="item.value"><span :style="setRadioStyle(item)" >{{ item.title }}</span></el-radio>  
                                  </template>
                                  <template v-else >
                                      <el-radio-button :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState)" v-for="(item, index) in field.options.config.options" :key="index" :label="item.value"><span :style="setRadioStyle(item)" >{{ item.title }}</span></el-radio-button>
                                  </template>
                                </el-radio-group> 
                            </el-form-item>
                        </div>
                    </template>

                    <template v-if="fieldSubType === 'multi'">
                        <div v-if="isPrintPage" key="printPage">
                            <el-form-item :label="field.name" :prop="field.formField">
                                <label class="print-page-label" v-for="(item, index) in field.options.config.options" :key="index">
                                    <input type="checkbox" :checked="categoryMultiValue.indexOf(item.value) > -1" disabled />
                                    {{ item.title }}
                                </label>
                            </el-form-item>
                        </div>
                        <div v-else key="printPage">
                            <el-form-item
                                v-if="field.options.required"
                                :label="field.name"
                                :prop="field.formField"
                                :rules="[{ required: true, message: '请至少选择一个' + field.name, trigger: 'change' }]"
                            >
                                <el-checkbox-group v-model="categoryMultiValue" :disabled="isReadOnly(field)">
                                    <el-checkbox :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState)" v-for="(item, index) in field.options.config.options" :key="index" :label="item.value">
                                        {{ item.title }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-else :label="field.name" :prop="field.formField">
                                <el-checkbox-group v-model="categoryMultiValue" :disabled="isReadOnly(field)">
                                    <el-checkbox :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState)" v-for="(item, index) in field.options.config.options" :key="index" :label="item.value">
                                        {{ item.title }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </template>
                </template>

                <template v-if="field.type === 'cascader'">
                    <div v-if="isPrintPage && field.options.config.type === 'multi'" key="printPage">
                        <el-form-item :label="field.name" :prop="field.formField">
                            <el-input style="width:100%" :disabled="isReadOnly(field) || isRead" v-model="formData[field.formField+'-view']" />
                        </el-form-item>
                    </div>
                    <div v-else key="printPage">
                        <el-form-item
                            v-if="field.options.required"
                            :label="field.name"
                            :prop="field.formField"
                            :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                            >
                            <el-cascader
                                :ref="field.formField"
                                :options="field.options.config.options"
                                :disabled="isReadOnly(field) || isRead"
                                v-model="formField"
                                @change="handleCascaderData"
                                :props="{
                                    label:'title',
                                    expandTrigger: 'hover',
                                    multiple: (field.options.config.type === 'multi')
                                }"
                                >
                            </el-cascader>
                        </el-form-item>

                        <el-form-item v-else :label="field.name" :prop="field.formField">
                            <el-cascader
                                :ref="field.formField"
                                :options="field.options.config.options"
                                :disabled="isReadOnly(field) || isRead"
                                v-model="formField"
                                @change="handleCascaderData"
                                :props="{
                                    label:'title',
                                    expandTrigger: 'hover',
                                    multiple: (field.options.config.type === 'multi')
                                }"
                                >
                            </el-cascader>
                        </el-form-item>
                    </div>
                </template>


                <template v-if="field.type === 'select'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <el-select :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState) || isSynLinkField" v-model="formField"  @change="handelSelectVal" clearable filterable allow-create default-first-option placeholder="请选择" >
                            <el-option v-for="item in field.options.config.options" :key="item.value" :label="item.title" :value="item.value" />
                        </el-select>
                    </el-form-item>

                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <el-select :disabled="isReadOnly(field) || (isRead || field.options.synApprovalState) || isSynLinkField" v-model="formField"  @change="handelSelectVal"  clearable filterable allow-create default-first-option placeholder="请选择">
                            <el-option v-for="item in field.options.config.options" :key="item.value" :label="item.title" :value="item.value" />
                        </el-select>
                    </el-form-item>
                </template>

                <template v-if="field.type === 'file'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请上传' + field.name, trigger: 'blur' }]"
                    >
                        <FieldItemFile :isRead="isReadOnly(field) || isRead" :field="field" ref="fileChild" :formData="formData" :formId="formId" :selectFiles="formField" :isFormDetail="true" :showFileList="false" :formBtnAuth="formBtnAuth" :isFromSubForm="isFromSubForm"  @dealFileData="dealFileData(field)"/>
                    </el-form-item>

                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <FieldItemFile :isRead="isReadOnly(field) || isRead" :field="field" ref="fileChild" :formData="formData" :formId="formId" :selectFiles="formField" :isFormDetail="true" :showFileList="false" :formBtnAuth="formBtnAuth" :isFromSubForm="isFromSubForm"  @dealFileData="dealFileData(field)"/>
                    </el-form-item>
                </template>

                <template v-if="field.type === 'link'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <FieldItemLink
                            :isRead="isReadOnly(field) || isRead"
                            :field="field"
                            :colSpan="colSpan"
                            ref="linkChild"
                            :formData="formData"
                            :formConfig="formConfig"
                            :taskInstance="taskInstance"
                            :selectFiles="formField"
                            :processModelFormsObj="processModelFormsObj"
                            :fieldsList="fieldsList"
                            :linkFieldCache="linkFieldCache"
                            @loadLinkData="loadLinkData"
                            @refreshViewField="refreshViewField"
                            @asynMainFormData="asynMainFormData"
                        />
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <FieldItemLink
                            :isRead="isReadOnly(field) || isRead"
                            :field="field"
                            :colSpan="colSpan"
                            ref="linkChild"
                            :formData="formData"
                            :formConfig="formConfig"
                            :taskInstance="taskInstance"
                            :selectFiles="formField"
                            :processModelFormsObj="processModelFormsObj"
                            :fieldsList="fieldsList"
                            :linkFieldCache="linkFieldCache"
                            @loadLinkData="loadLinkData"
                            @refreshViewField="refreshViewField"
                            @asynMainFormData="asynMainFormData"
                        />
                    </el-form-item>
                </template>

                <template v-if="field.type === 'subform'">
                    <template v-if="subFormViewMode===0">
                      <el-form-item v-if="field.options.required" :label="field.name" :prop="field.formField" :rules="[{ required: true, message: '请新增' + field.name, trigger: 'change' }]">
                          <FieldSubform ref="fieldSubformRef" :fieldsList="fieldsList" :isPrintPage="isPrintPage" :isRead="isReadOnly(field) || isRead" :subformIsRead="subformIsRead" :subform="field" :formData="formData" :key="loadTimer" @refreshViewField="refreshViewField" :approvalStatus="approvalStatus" :taskInstance="taskInstance"/>
                      </el-form-item>
                      <el-form-item v-else :label="field.name" :prop="field.formField" >
                          <FieldSubform ref="fieldSubformRef" :fieldsList="fieldsList" :isPrintPage="isPrintPage" :isRead="isReadOnly(field) || isRead" :subformIsRead="subformIsRead" :subform="field" :formData="formData" :key="loadTimer" @refreshViewField="refreshViewField" :approvalStatus="approvalStatus" :taskInstance="taskInstance"/>
                      </el-form-item>
                    </template>
                    <template v-else>
                        <FieldSubform ref="fieldSubformRef" :fieldsList="fieldsList" :isPrintPage="isPrintPage" :isRead="isReadOnly(field) || isRead" :subformIsRead="subformIsRead" :subform="field" :formData="formData" :key="loadTimer" @refreshViewField="refreshViewField" :approvalStatus="approvalStatus" :taskInstance="taskInstance"/>
                    </template>
                </template>
                <template v-if="field.type === 'dictionary'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <DictionaryTree :isRead="isReadOnly(field) || isRead" v-if="fieldSubType === 'single'" ref="treeChild" :defaultClass="'dictionary-tree-form'" :field="field" :rootId="treeRoot.id" :popover="true" @nodeClick="handleTreeNode" />
                        <DictionaryTree
                            :isRead="isReadOnly(field) || isRead"
                            v-if="fieldSubType === 'multi'"
                            ref="treeChild"
                            :defaultClass="'dictionary-tree-form'"
                            :multiple="true"
                            :rootId="treeRoot.id"
                            :popover="true"
                            :field="field"
                            @nodeClick="handleTreeNode"
                        />
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <DictionaryTree :isRead="isReadOnly(field) || isRead" v-if="fieldSubType === 'single'" :field="field" :defaultClass="'dictionary-tree-form'" ref="treeChild" :rootId="treeRoot.id" :popover="true" @nodeClick="handleTreeNode" />
                        <DictionaryTree
                            :isRead="isReadOnly(field) || isRead"
                            v-if="fieldSubType === 'multi'"
                            ref="treeChild"
                            :multiple="true"
                            :rootId="treeRoot.id"
                            :defaultClass="'dictionary-tree-form'"
                            :popover="true"
                            :field="field"
                            @nodeClick="handleTreeNode"
                        />
                    </el-form-item>
                </template>

                <template v-if="field.type === 'serialNumber'">
                    <template v-if="field.options.ext3==='2' || field.options.ext3==='4' || field.options.ext3==='5' || field.options.ext3==='6'">
                        <el-form-item  :label="field.name" :prop="field.formField">
                            <template v-if="!this.formData.hasOwnProperty('id') && !this.formData.hasOwnProperty(field.formField +'-sn')">
                                <el-tag  type="info" >系统根据规则自动生成流水号</el-tag>
                            </template>
                            <template v-else>
                                {{formField ? formField : '' }}
                            </template>
                        </el-form-item>
                    </template>
                    <template v-else>
                      <el-form-item
                          v-if="field.options.required"
                          :label="field.name"
                          :prop="field.formField"
                          :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                      >
                        <el-row>
                            <el-col :span="22">
                                <el-input :disabled="isReadOnly(field) || isRead" v-model="formField" @change="checkSerialNumberIfExist(formField)" />
                                <SerialNumber :isRead="isReadOnly(field) || isRead" v-if="fieldSubType === 'multi'" :defaultClass="'serialnumber-tree-form'" ref="treeChild" :rootId="treeRoot.id" :popover="true" @nodeClick="handleTreeNode" />
                            </el-col>
                            <el-col :span="2" v-if="(!field.options.ext3 || field.options.ext3 === '1')">
                                <el-tooltip content="重新获取一个新的流水号" placement="top" popper-class="field-tips">
                                    <el-button
                                        type="primary"
                                        :loading="reSetLoading"
                                        size="mini"
                                        icon="el-icon-refresh-right"
                                        :disabled="isReadOnly(field) || isRead"
                                        style="margin-left: 5px;margin-top: 7px;"
                                        title="刷新"
                                        circle
                                        @click="reSetSerialNumber(field)"
                                    ></el-button>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                      </el-form-item>
                      <el-form-item v-else :label="field.name" :prop="field.formField">
                          <el-row>
                              <el-col :span="22">
                                  <el-input :disabled="isReadOnly(field) || isRead" v-model="formField" @change="checkSerialNumberIfExist(formField)" />
                                  <SerialNumber :isRead="isReadOnly(field) || isRead" v-if="fieldSubType === 'multi'" ref="treeChild" :defaultClass="'serialnumber-tree-form'" :rootId="treeRoot.id" :popover="true" @nodeClick="handleTreeNode" />
                              </el-col>
                              <el-col :span="2" v-if="(!field.options.ext3 || field.options.ext3 === '1')">
                                  <el-tooltip content="重新获取一个新的流水号" placement="top" popper-class="field-tips">
                                      <el-button
                                          type="primary"
                                          :loading="reSetLoading"
                                          size="mini"
                                          icon="el-icon-refresh-right"
                                          :disabled="isRead"
                                          style="margin-left: 5px;margin-top: 7px;"
                                          title="刷新"
                                          circle
                                          @click="reSetSerialNumber(field)"
                                      ></el-button>
                                  </el-tooltip>
                              </el-col>
                          </el-row>
                      </el-form-item>
                    </template>
                </template>

                <template v-if="field.type === 'businessTree'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <BusinessTree :isRead="isReadOnly(field) || isRead" ref="treeChild" :rootId="treeRoot.id" :defaultClass="'business-tree-form'" :popover="true" @nodeClick="handleTreeNode" :field="field"/>
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <BusinessTree :isRead="isReadOnly(field) || isRead" ref="treeChild" :rootId="treeRoot.id" :defaultClass="'business-tree-form'" :popover="true" @nodeClick="handleTreeNode" :field="field"/>
                    </el-form-item>
                </template>

                <template v-if="field.type === 'user'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <el-tooltip :disabled="isReadOnly(field) || !selectedUser.selectedUserNames" :content="selectedUser.selectedUserNames" effect="light" placement="top" popper-class="field-tips">
                            <el-input v-if="isRead" :disabled="isReadOnly(field) || isRead || isSynLinkField" v-model="selectedUser.selectedUserNames"></el-input>
                            <el-input v-else readonly :disabled="isReadOnly(field) || isRead || isSynLinkField" v-model="selectedUser.selectedUserNames" @focus="chooseUser"></el-input>
                        </el-tooltip>
                        <!-- <el-row>
                            <el-button @click="chooseUser">添加人员</el-button>
                        </el-row>
                        <el-row>
                            <el-tag type="danger" v-for="(item,index) in selectedUser.selectedUserNames.split(',').length" :key="index">{{item}}</el-tag>
                        </el-row> -->
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <el-tooltip :disabled="isReadOnly(field) || !selectedUser.selectedUserNames" :content="selectedUser.selectedUserNames" effect="light" placement="top" popper-class="field-tips">
                            <el-input v-if="isRead" :disabled="isReadOnly(field) || isRead || isSynLinkField" v-model="selectedUser.selectedUserNames"></el-input>
                            <el-input v-else readonly :disabled="isReadOnly(field) || isRead || isSynLinkField" v-model="selectedUser.selectedUserNames" @focus="chooseUser"></el-input>
                        </el-tooltip>
                        <!-- <el-row>
                            <el-button @click="chooseUser">添加人员</el-button>
                        </el-row> -->
                    </el-form-item>
                    <UserOrgPop
                        v-if="!isRead"
                        :multiple="fieldSubType === 'multi'"
                        :isShowUserOrg="isShowUserOrg"
                        :field="field"
                        :selectedUser="selectedUser"
                        :formConfig="formConfig"
                        ref="userChild"
                        @showUserDetail="showUserDetail"
                        @autoUserCompleteData="autoUserCompleteData"
                        @renderLinkField="renderLinkField"
                        :formData="formData"
                    />
                    <el-form-item v-if="selectedUser.pageData.length > 0 " :label="field.name+'详细信息'">
                       <template  v-if="selectedUser.pageData.length > 0 ">
                            <DynamicTable
                               :tableColumns="selectedUser.tableColumns"
                               :tableData="selectedUser.pageData"
                               :isShowCheckbox="false"
                               :isSortable="true"
                               :isShowPageSizes="true"
                               :key="timer"
                               >
                              </DynamicTable>
                        </template>
                    </el-form-item>
                </template>
                <template v-if="field.type === 'process'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <!-- <el-tooltip :disabled="isReadOnly(field) || !selectedProcess.selectedProcessNames" :content="selectedProcess.selectedProcessNames" effect="light" placement="top" popper-class="field-tips">
                            <el-input v-if="isRead" disabled v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess"></el-input>
                            <el-input v-else readonly v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess"></el-input>
                        </el-tooltip> -->
                        <el-tooltip :disabled="isReadOnly(field) || !selectedProcess.selectedProcessNames" :content="selectedProcess.selectedProcessNames" effect="light" placement="top" popper-class="field-tips">
                            <el-input   v-if="isRead" disabled v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess">
                                <el-button slot="append" icon="el-icon-link" @click="seeProcessDetail"></el-button>
                            </el-input>
                            <el-input v-else readonly v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess">
                                <el-button slot="append" icon="el-icon-link" @click="seeProcessDetail"></el-button>
                            </el-input>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <el-tooltip :disabled="isReadOnly(field) || !selectedProcess.selectedProcessNames" :content="selectedProcess.selectedProcessNames" effect="light" placement="top"  popper-class="field-tips">
                            <!-- <el-input v-if="isReadOnly(field) || isRead" disabled v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess"></el-input>
                            <el-input v-else readonly v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess"></el-input> -->
                            <el-input  v-if="isReadOnly(field) || isRead" disabled v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess">
                                <el-button slot="append" icon="el-icon-link" @click="seeProcessDetail"></el-button>
                            </el-input>
                            <el-input v-else readonly v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess">
                                <el-button slot="append" icon="el-icon-link" @click="seeProcessDetail"></el-button>
                            </el-input>
                        </el-tooltip>
                        <!-- <el-tooltip :disabled="isReadOnly(field) || !selectedProcess.selectedProcessNames" :content="selectedProcess.selectedProcessNames" effect="light" placement="top"  popper-class="field-tips">
                            <el-input v-if="isReadOnly(field) || isRead" disabled v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess"></el-input>
                            <el-input v-else readonly v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess"></el-input>
                        </el-tooltip> -->
                    </el-form-item>
                    <!-- <ProcessSelectPop
                        v-if="!isRead"
                        :multiple="false"
                        :isShowProcessPop="isShowProcessPop"
                        :field="field"
                        :selectedProcess="selectedProcess"
                        ref="processPop"
                        :formData="formData"
                    /> -->
                    <el-dialog
                        v-if="isShowProcessPop"
                        title="选择流程"
                        :visible.sync="isShowProcessPop"
                        append-to-body
                        top="4vh"
                        width="95%"
                        >
                        <ProcessSelectPop v-if="!isRead&&isShowProcessPop" ref="processPop" :multiple="false" :selectedProcess="selectedProcess" :formData="formData" :field="field" @nodeClick="selectProcessTrigger" />
                    </el-dialog>
                </template>

                <template v-if="field.type === 'divider'">
                    <el-divider content-position="left">{{ field.name }}</el-divider>
                </template>

                <template v-if="field.type === 'address'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                        :prop="field.formField">
                        <el-cascader :options="getOptionsData(field)" :disabled="isReadOnly(field)" v-model="selectedOptions" @change="handleChangeData" :separator="' '" clearable></el-cascader>
                    </el-form-item>
                    <el-form-item
                        v-else
                        :label="field.name"
                        :prop="field.formField">
                        <el-cascader :options="getOptionsData(field)" :disabled="isReadOnly(field)" v-model="selectedOptions" @change="handleChangeData" :separator="' '" clearable></el-cascader>
                    </el-form-item>
                </template>

                <template v-if="field.type === 'department'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <Department
                            :isRead="isReadOnly(field) || isRead || isSynLinkField"
                            :multiple="fieldSubType === 'multi'"
                            ref="treeChild"
                            :rootId="treeRoot.id"
                            :popover="true"
                            :field="field"
                            :ifFiltDataSource="true"
                            @nodeClick="handleTreeNode"
                        />
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <Department
                            :isRead="isReadOnly(field) || isRead || isSynLinkField"
                            :multiple="fieldSubType === 'multi'"
                            ref="treeChild"
                            :rootId="treeRoot.id"
                            :popover="true"
                            :ifFiltDataSource="true"
                            :field="field"
                            @nodeClick="handleTreeNode"
                        />
                    </el-form-item>
                </template>
                <!-- 角色字段，仅人员扩展表用 -->
                <template v-if="field.type === 'role'">
                   <el-form-item
                       v-if="field.options.required"
                       :label="field.name"
                       :prop="field.formField"
                       :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                   >
                       <el-select :disabled="isRead" v-model="formField"  @change="handelSelectVal" clearable filterable allow-create default-first-option placeholder="请选择" >
                           <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id" />
                       </el-select>
                   </el-form-item>

                   <el-form-item v-else :label="field.name" :prop="field.formField">
                       <el-select :disabled="isRead" v-model="formField"  @change="handelSelectVal"  clearable filterable allow-create default-first-option placeholder="请选择">
                           <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id" />
                       </el-select>
                   </el-form-item>
                </template>
                <!-- 岗位字段，仅人员扩展表用 -->
                <template v-if="field.type === 'position'">
                   <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :prop="field.formField"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                        <Position
                            ref="positionTreeChild"
                            :rootId="treeRoot.id"
                            :popover="true"
                            :isRead="true"
                            :multiple="fieldSubType === 'multi'"
                            :ifFiltDataSource="true"
                            @nodeClick="handleTreeNode"
                        />
                    </el-form-item>
                    <el-form-item v-else :label="field.name" :prop="field.formField">
                        <Position
                            ref="positionTreeChild"
                            :rootId="treeRoot.id"
                            :isRead="true"
                            :popover="true"
                            :multiple="fieldSubType === 'multi'"
                            :ifFiltDataSource="true"
                            @nodeClick="handleTreeNode"
                        />
                    </el-form-item>
                </template>

                <template v-if="field.type === 'archive'">
                    <el-form-item
                        v-if="field.options.required"
                        :label="field.name"
                        :rules="[{ required: true, message: '请选择' + field.name, trigger: 'change' }]"
                    >
                      <FieldItemArchive
                          :field="field"
                          :rootId="treeRoot&&treeRoot.id?treeRoot.id:''"
                          ref="fieldItemArchive"
                          :formData="formData"
                          :fieldsList="fieldsList"
                          :isBelongApproval="isBelongApproval"
                          :isRequired="true"
                      />
                    </el-form-item>

                    <el-form-item v-else :label="field.name">
                        <FieldItemArchive
                            :field="field"
                            :rootId="treeRoot&&treeRoot.id?treeRoot.id:''"
                            ref="fieldItemArchive"
                            :formData="formData"
                            :isBelongApproval="isBelongApproval"
                            :fieldsList="fieldsList"
                        />
                    </el-form-item>
                </template>
                <!-- 定位 -->
                <template v-if="field.type === 'location'">
                    <el-form-item  :label="field.name">
                         <el-input placeholder="定位选择"  v-model="formField" class="input-with-select" readonly="readonly">
                            <el-button slot="append" icon="el-icon-location-outline" @click="showMapsChoose(field)"></el-button>
                          </el-input>
                    </el-form-item>
                </template>
            </el-col>
            <el-col v-if="field.options.description" :span="isPrintPage ? 0 : 2" class="field-des">
                <el-popover placement="left" title="填写说明：" width="430" trigger="hover">
                    {{ field.options.description }}
                    <template  v-if="field.type === 'calculation' && field.options.formulaExp != undefined && ((field.options.formulaExp.indexOf(';') !== -1)||(field.options.formulaExp.indexOf(',')!== -1))">
                        <el-button slot="reference" circle icon="el-icon-view" @click="showCalculationDetail(field)"></el-button>
                        <!-- <el-button slot="reference" circle icon="el-icon-question"></el-button> -->
                    </template>
                    <template  v-else-if="field.type === 'text' && field.options.synLinkFormField && field.options.synLinkFormField.options.formulaExp != undefined && ((field.options.synLinkFormField.options.formulaExp.indexOf(';') !== -1)||(field.options.synLinkFormField.options.formulaExp.indexOf(',')!== -1))">
                        <el-button slot="reference" circle icon="el-icon-view" @click="showCalculationDetail(field.options.synLinkFormField, field)"></el-button>
                    </template>
                    <template v-else >
                      <el-button slot="reference" circle icon="el-icon-question"></el-button>
                    </template>
                </el-popover>
            </el-col>
        </el-row>
        <el-dialog
            title="数据分布"
            top="4vh"
            width="80vw"
            custom-class="form-show-map"
            :visible.sync="active"
            v-if="active"
            append-to-body>
            <ShowMaps
                ref="detailRef"
                :mapsInfo="mapsInfo"
                @configLocationArray="configLocationArray"
                @hideSidebox="hideSidebox"/>
        </el-dialog>
        <el-dialog
            title="选择位置"
            top="4vh"
            width="80vw"
            custom-class="choose-form-show-map"
            :visible.sync="isChooseMap"
            v-if="isChooseMap"
            append-to-body>
            <ChooseMaps
                ref="detailRef"
                :locationInfo="locationInfo"
                :locationValue="locationValue"
                @saveLocationInfo="saveLocationInfo"
                @cancelLocationInfo="cancelLocationInfo"/>
        </el-dialog>

        <el-dialog
          :title="refModelTitle"
          top="2vh"
          width="80%"
          :visible.sync="showRelateFormDialog"
          fullscreen 
          append-to-body>
          <!-- 关联的其他表单数据 -->
          <!--  -->
            <div class="render-form-item" v-if="showRelateFormTab" style="width: 100%; height:500px; float: left;">
                  <el-row>
                      <el-form-item class="relateFormTab" label="" style="width: 100%;">
                        <el-tabs :key="loadTimerRelate" @tab-click="handleRelateFormTabClick" v-model="relateFormTabName" >
                            <template v-for="(model, index3) in refModelList" >
                                <el-tab-pane :key="model.id" :label="model.modelName" :name="model.id">
                                    <RelateFormList
                                        :ref="'refModelList' + model.id"
                                        :key="loadTimerRelate"
                                        :selectedModel="model"
                                        :ifShowBtn="false" 
                                        :viewData="true"
                                        :isCalcul="true"
                                        :tempFormData="tempFormData"
                                        :parentFormInfo="parentFormInfo"
                                        :parentFormData="parentFormDataArr"
                                    />
                                </el-tab-pane>
                            </template>
                        </el-tabs>
                      </el-form-item>
                  </el-row>
              </div>
      </el-dialog>
      <el-dialog
          title="流程详情"
          :fullscreen="true"
          append-to-body
          :visible.sync="isShowProcessInstanceDetail"
          >
         <ProcessDetail
            v-if="isShowDetail"
            :key="loadProcessTimer"
            :instances="instancesInfo"
            :isRead="true"
          />
      </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FieldItemArchive from './FieldItemArchive';
import FieldItemFile from './FieldItemFile';
import FieldItemLink from './FieldItemLink';
import ChooseMaps from '@/components/FieldProps/ChooseMaps';
import ShowMaps from '@/components/FieldProps/ShowMaps';
import Editorbar from '@/components/WangEditor';
import RelateFormList from '@/pages/business/BusinessApplication/RelateFormList.vue';
import FieldSubform from './FieldSubform';
import ProcessSlider from '@/components/ProcessSlider';
import * as formBaseField from '@/components/CustomForm/formBaseField';
import { cloneDeep, isEmpty } from 'lodash';
import { objectKeyIsEmpty } from '@/utils/grocer';
import { getSingleFieldDataList, getModelListByRefFormIds, getModelFormInstanceById, checkSerialNumberIfExist, getSerialNumber, saveConfigOption, saveCalculation, saveSubFormSummary, getDepartmentDetail,
    getUpMoneyFieldList, getRoleList, getUserExtendDataIds, getModelFormReportList, getModelServiceList, getEmployeeListByDepartmentId, getProcessInstancesUsers, getProcessInstancesDetail, getFormConfig } from '@/data-model';
import options from '@/utils/country-level3-data.js';
import option from '@/utils/country-level2-data.js';
import { formatDate } from '@/utils/date.js';
import UserPop from '@/components/UserOrgPop/UserPop';
import UserOrgPop from '@/components/UserOrgPop/UserOrgPop';
import { systemType } from '@/common/constants/const-global';
export default {
    components: {
        RelateFormList,
        FieldItemFile,
        FieldItemLink,
        FieldSubform,
        FieldItemArchive,
        ChooseMaps,
        ShowMaps,
        ProcessSlider,
        Editorbar,
        UserOrgPop: systemType === 'partyBuilding' ? UserPop : UserOrgPop
    },
    data () {
        return {
            timeout: null,
            currentMainFormInfo: {mainFormDataId: '', mainFormId: ''},
            dateValueformat: 'yyyy-MM-dd',
            dateTimeValueformat: 'yyyy-MM-dd HH:mm:ss',
            dateType: 'date',
            showMoneyText: false,
            reSetLoading: false,
            placeholderContent: '',
            approvalRemarksStyle: '',
            isShowProcessPop: false,
            treeData: [],
            numberObj: {},
            isShowUserOrg: false,
            selectedUser: {
                selectedUserIds: '',
                selectedUserNames: '',
                tableColumns: [],
                pageData: [],
                extendDataIds: ''
            },
            selectedProcess: {
                processIds: '',
                selectedProcessNames: ''
            },
            isNeed: false,
            subformIsRead: false,
            selectedOptions: [], // 存放默认值
            options: options, // 存放城市数据也就是显示出来
            addr: {
                detail: '', // 详细地址信息
                detailMap: '', // 城市地址详细地址拼接
                address: '' // 省份城市
            },
            ext1: '',
            isSaveCompute: false,
            active: false,
            isChooseMap: false,
            mapsInfo: {},
            locationInfo: {},
            locationValue: '',
            roleList: [],
            userExtendConfig: {},
            timer: '',
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            loadTimer: '',
            numberType: 'number',
            showRelateFormTab: false,
            showRelateFormDialog: false,
            tempFormData: [], // 将要新增的关联表单数据
            relateFormTabName: '',
            loadTimerRelate: '',
            refModelTitle: '',
            refModelList: [], // 关联的表单
            // progressStatus: this.getProgressStatus(),
            progressContent: '输入进度值，不能超过100',
            editorbarVal: '',
            instancesInfo: {},
            isShowDetail: false,
            isShowProcessInstanceDetail: false,
            loadProcessTimer: '',
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: []
            },
            searchCondition: [],
            defaultConditonsMap: new Map(), // 默认设置关联数据的过滤条件map
            searchConditionExt: [],
            defaultTime: new Date(), // 当前时间
            dateRelationSettingMap: new Map() // 存放时间字段值，进行是否有变化的比对
        };
    },
    filters: {
        moneyFomater: function (value) {
            if (!value) {
                return '0.00';
            }

            /* 原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1 */
            let intPart = Number(value) | 0; // 获取整数部分
            let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
            let floatPart = '.00'; // 预定义小数部分
            let value2Array = value.toString().split('.');
            let isNegtiveNo = '';
            if (intPartFormat === 0) {
                if (value.toString().indexOf('-') !== 1) {
                    isNegtiveNo = '-'; // 修复小于0负数丢失的问题
                }
            }
            // =2表示数据有小数位
            if (value2Array.length === 2) {
                floatPart = value2Array[1].toString(); // 拿到小数部分
                if (floatPart.length === 1) { // 补0,实际上用不着
                    return isNegtiveNo + intPartFormat + '.' + floatPart + '0';
                } else {
                    return isNegtiveNo + intPartFormat + '.' + floatPart;
                }
            } else {
                return isNegtiveNo + intPartFormat + floatPart;
            }
        }
    },
    props: {
        field: {
            type: Object,
            required: true
        },
        mainInstanceId: {
            type: String
        },
        parentFormInfo: {
            type: Object
        },
        parentFormDataArr: { // 对于关联子表来说的父表单数据
            type: Array,
            default: () => []
        },
        formData: {
            type: [Object, String],
            required: true
        },
        formConfig: {
            type: Object
        },
        colSpan: {
            type: Number
        },
        parentFormData: {
            // 对于子表单来说的父表单数据
            type: [Object, String]
        },
        formId: {
            type: String
        },
        findex: {
            type: Number
        },
        formIndex: {// 表单序号，用于多表单时，通过序号寻找是第几个表单
            type: Number,
            default: 0
        },
        isView: {
            type: Boolean,
            default: true
        },
        isRead: {
            type: Boolean,
            default: false
        },
        approvalUserList: {
            // 对审批流质检表单需要填充的审批人列表
            type: Array,
            default: () => {
                return [];
            }
        },
        isBelongApproval: {
            // 是否是审批流
            type: Boolean,
            default: false
        },
        subformIsReadOuter: {
            type: Boolean,
            default: false
        },
        isApproval: {
            // 是否是审批流字段
            type: Boolean,
            default: false
        },
        isFromSubForm: {
            // 是否是子表单内字段
            type: Boolean,
            default: false
        },
        isPrintPage: {
            // 是否是打印页面
            type: Boolean,
            default: false
        },
        taskInstance: {
            type: Object
        },
        processInstance: {
            type: Object
        },
        processModelFormsObj: {
            type: Array
        },
        fieldsList: {
            type: Array
        },
        subFormViewMode: {// 子表单显示模式
            type: Number,
            default: 0
        },
        reqSouce: {
            type: Number,
            default: 0
        },
        formBtnAuth: {
            type: Object
        },
        linkFieldCache: {
            type: Map,
            default: () => new Map()
        },
        relateModelList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        approvalStatus: {
            type: Number,
            default: 0
        }
    },
    created () {
        this.field.formField = this.field.id;
        this._setProps();
        // 所属流程字段默认当前流程
        if (!isEmpty(this.processInstance)) {
            this.selectedProcess.processIds = this.processInstance.id;
            this.selectedProcess.selectedProcessIds = this.processInstance.id;
            this.selectedProcess.selectedProcessNames = this.processInstance.name;
            if (this.field.type === 'process') {
                this.formData[this.field.formField + '-view'] = this.selectedProcess.selectedProcessNames;
                this.formData[this.field.formField] = this.selectedProcess.selectedProcessIds;
            }
        }
        if (this.field.type === 'role') {
            this.getRoleList();
        }
    },
    computed: {
        isSynLinkField () { // 是否是关联映射字段
            if (this.field.options.hasOwnProperty('synLinkField')) {
                if (isEmpty(this.field.options.synLinkField)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        formField: {
            set (newVal, oldVal) {
                this.$set(this.formData, this.field.formField, newVal);
                this.formData[this.field.formField + '-view'] = '';
                if (newVal) {
                    if (this.field.type === 'category' || this.field.type === 'select') {
                        let obj = { title: '' };
                        obj = this.field.options.config.options.find(item => {
                            return item.value === newVal;
                        });
                        if (obj) {
                            this.formData[this.field.formField + '-view'] = obj.title; // 针对选项、下拉进行名称赋值
                        } else if (this.field.type === 'select') {
                            let selOption = {
                                id: '',
                                title: newVal,
                                value: newVal,
                                def: false,
                                optionConfigId: this.field.options.config.id,
                                formId: this.formId
                            };
                            this.field.options.config.options.push(selOption);
                            this.formData[this.field.formField + '-view'] = newVal; // 针对选项、下拉进行名称赋值
                            this.handleSaveOption(selOption);
                        }
                    } else if (this.field.type === 'process') {
                        this.formData[this.field.formField + '-view'] = this.selectedProcess.selectedProcessNames;
                        this.formData[this.field.formField] = this.selectedProcess.selectedProcessIds;
                    } else if (this.field.type === 'number' || this.field.type === 'calculation') {
                        let finalVal = newVal;
                        if (this.numberType === 'number') {
                            finalVal = this.checkNumber(newVal, this.field.options.decimal);
                            // if ((this.field.options.isProgress || this.field.options.percentage) && (finalVal > 100 || finalVal < -100)) {客户个性化需求，移除此处限制
                            //     finalVal = 0;
                            //     this.$message.error('数字不能超过100,请修改。');
                            // }
                        }
                        // if (this.field.options.isProgress) {
                        //     finalVal = !finalVal ? 0 : parseInt(finalVal);
                        //     this.progressStatus = this.getProgressStatus();
                        // }
                        this.$set(this.formData, this.field.formField, finalVal);
                    } else if (this.field.type === 'role') {
                        for (let i = 0; i < this.roleList.length; i++) {
                            let obj = this.roleList[i];
                            if (obj.id === newVal) {
                                this.formData[this.field.formField + '-view'] = obj.roleName;
                            }
                        }
                        this.formData[this.field.formField] = newVal;
                    } else if (this.field.type === 'text') {
                        let ext2 = this.field.options.ext2;
                        if (ext2) {
                            let obj = JSON.parse(ext2);
                            if (obj.fieldMaxLength) {
                                if (newVal.length > obj.fieldMaxLength) {
                                    this.formData[this.field.formField] = newVal.substring(0, obj.fieldMaxLength);
                                }
                            }
                        }
                    } else if (this.field.type === 'date' || this.fieldSubType === 'datetime' || this.field.options.config.type === 'daterange') {
                        if (this.fieldsList && Array.isArray(this.fieldsList)) {
                            let isReset = false;
                            this.fieldsList.forEach(fieldObj => {
                                if (fieldObj.type === 'number' && fieldObj.options.isProgress && fieldObj.options.progressDateField === this.field.id) {
                                    isReset = true;
                                    return false;
                                }
                            });
                            if (isReset) {
                                this.$emit('refreshViewField');
                            }
                        }
                    }
                }
            },
            get (val) {
                if (this.field.type === 'file') {
                    if (Array.isArray(this.formData[this.field.formField])) {
                        setTimeout(() => {
                            if (this.$refs.fileChild) {
                                // 默认回显值
                                this.$refs.fileChild._setDefaultFiles(this.formData[this.field.formField]);
                            }
                        }, 0);
                    }
                } else if (this.field.type === 'link') {
                    if (this.formData[this.field.formField] !== '') {
                        setTimeout(() => {
                            if (this.$refs.linkChild) {
                                // 默认回显值
                                this.$refs.linkChild.setEditData(this.field.options.config.form);
                            }
                        }, 0);
                    }
                } else if (this.field.type === 'archive') {
                    if (this.formData[this.field.formField] !== '') {
                        setTimeout(() => {
                            // 默认回显值
                            // this.$refs.linkChild.setEditData(this.field.options.config.form);
                        }, 0);
                    }
                } else if (this.field.type === 'role') {
                    let ids = '';
                    for (let i = 0; i < this.roleList.length; i++) {
                        let obj = this.roleList[i];
                        ids = ids + obj.id + ',';
                    }
                    if (ids.indexOf(this.formData[this.field.formField]) !== -1) {
                        return this.formData[this.field.formField];
                    } else {
                        return '';
                    }
                }
                return this.formData[this.field.formField];
            }
        },
        fieldSubType () {
            return this.field.options.config.type;
        },
        categoryMultiValue: {
            get (val) {
                let formField = this.field.formField;
                if (this.formData[formField]) {
                    return this.formData[formField] === '' ? [] : this.formData[formField].split(',');
                } else {
                    return [];
                }
            },
            set (newVal, oldVal) {
                let formField = this.field.formField;
                this.formData[formField] = newVal.join(',');
                let viewArr = newVal;
                let viewData = [];
                // let showColorView = [];
                for (var i = 0; i < viewArr.length; i++) {
                    let obj = {};
                    obj = this.field.options.config.options.find(item => {
                        return item.value === viewArr[i];
                    });
                    viewData.push(obj.title);
                }
                let key = this.field.id + '-view';
                this.formData[key] = viewData.join(','); // 针对选项、下拉进行名称赋值(多选)
            }
        },
        treeRoot () {
            if (
                this.field.options.config.type === 'single' ||
                this.field.type === 'serialNumber' ||
                (this.field.options.config.type === 'multi' && (this.field.type === 'dictionary' || this.field.type === 'department' || this.field.type === 'archive' || this.field.type === 'position'))
            ) {
                if (this.field.options.config.options[0]) {
                    return {
                        id: this.field.options.config.options[0].value,
                        label: this.field.options.config.options[0].title
                    };
                } else {
                    return {
                        id: '',
                        label: ''
                    };
                }
            }
        },
        ...mapGetters([
            'userInfo'
        ])
    },
    watch: {
        'formField' (newVal, oldVal) {
            if (this.field.type === 'select' || (this.field.type === 'category' && this.field.options.config.type === 'single')) { // 下拉和单选的选项才走此方法
                this.handelSelectVal(newVal);
            } else if (this.field.type === 'user' || this.field.type === 'department') {
                this.$emit('refreshViewField');
            } else if (this.field.type === 'calculation') {
                this.upMoneyField();
            } else if (this.field.type === 'date') {
                this.upDynamicDateField();
            }
        }
    },
    methods: {
        renderFormRef () {
            if (this.fieldsList && Array.isArray(this.fieldsList)) {
                this.fieldsList.forEach(fieldObj => {
                    this.isShowField(fieldObj);
                });
                this.$emit('refreshViewField');
            }
        },
        async getRoleList () {
            let formData = await getRoleList(1, 100000, '');
            if (formData && formData.data) {
                this.roleList = formData.data;
            }
        },
        jumpLinks (url) {
            let zz = '(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]';
            let reg = new RegExp(zz);
            if (!reg.test(url)) {
                this.$message.error('链接地址不合法,请修改。');
                return false;
            }
            window.open(url);
        },
        checkExt1 () {
            let zz = '(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]';
            let reg = new RegExp(zz);
            if (!reg.test(this.ext1)) {
                this.$message.error('提示！！！输入的链接网址不正确,会导致链接无效!');
                return false;
            }
        },
        checkNumber (val, rule) {
            var t = val.charAt(0);
            let b = '([0-9]+\\.[0-9]{' + rule + '})[0-9]*';
            var reg = new RegExp(b, '');
            val = val.replace('.', '$#$')// 把第一个字符'.'替换成'$#$'
                .replace(/\./g, '')// 把其余的字符'.'替换为空
                .replace('$#$', '.')// 把字符'$#$'替换回原来的'.'
                .replace(/[^\d.]/g, '')// 只能输入数字和'.'
                .replace(/^\./g, '')// 不能以'.'开头
                .replace(reg, '$1');// 保留对应的小数位数
            if (t === '-') {
                val = '-' + val;
            }
            return val;
        },
        async _setProps () {
            if (this.field.type === 'dictionary' || this.field.type === 'businessTree' || this.field.type === 'department') {
                // 数据字典、业务分类、部门
                let node = {};
                node.title = this.formData[this.field.formField + '-tree'];
                node.value = this.formData[this.field.formField];
                setTimeout(() => {
                    // 默认回显值
                    if (this.$refs.treeChild) {
                        this.$refs.treeChild._refreshSelectedNode(node);
                    }
                }, 0);
            } else if (this.field.type === 'serialNumber') {
                // 流水号
                if (!this.field.options.ext3) {
                    // 未设置流水号的生成方式，则采用默认自动生
                    if (!this.formData[this.field.formField] && this.fieldSubType !== 'multi') {
                        // 单选
                        let val = this.field.options.config.options.length > 0 ? this.field.options.config.options[0].value : '';
                        this.setSerialNumber(val);
                    } else if (this.fieldSubType === 'multi') {
                        let node = {};
                        node.title = this.formData[this.field.formField + '-tree'];
                        node.value = this.formData[this.field.formField + '-sn'];
                        setTimeout(() => {
                            if (this.$refs.treeChild) {
                                // 默认回显值
                                this.$refs.treeChild._refreshSelectedNode(node);
                            }
                        }, 0);
                    }
                }
            } else if (this.field.type === 'user') {
                if (isEmpty(this.formData[this.field.formField]) && isEmpty(this.formData[this.field.formField + '-user'])) {
                    // 假如没有值则默认选中当前登录人
                    if (this.field.options.defaultValue === 'true' && (this.isAddFormField() || (!this.isFromSubForm && this.isBelongApproval && !this.formData.id))) {
                        this.selectedUser.selectedUserIds = this.userInfo.userId;
                        this.selectedUser.selectedUserNames = this.userInfo.trueName;
                        this.formData[this.field.formField] = this.userInfo.userId;
                        this.formData[this.field.formField + '-user'] = this.userInfo.trueName;
                        // await this.setUserExtCascadeData();
                    } else if (this.field.ext1 && this.fieldSubType === 'multi') { // 通过岗位规则约束人员范围
                        let positionIds = null;
                        if (this.field.ext1) { // 假如有岗位规则的约束时增加岗位规则
                            positionIds = JSON.parse(this.field.ext1).join(',');
                            let employeeInDeptListData = await getEmployeeListByDepartmentId(0, 1000, null, null, positionIds);
                            if (employeeInDeptListData && employeeInDeptListData.data) {
                                let sourceUser = cloneDeep(employeeInDeptListData.data);
                                if (sourceUser && sourceUser.length > 0) {
                                    let selectedUserIdsArr = [];
                                    let selectedUserNamesArr = [];
                                    for (let i = 0; i < sourceUser.length; i++) {
                                        selectedUserIdsArr.push(sourceUser[i].id);
                                        selectedUserNamesArr.push(sourceUser[i].trueName);
                                    }
                                    this.selectedUser.selectedUserIds = selectedUserIdsArr.join(',');
                                    this.selectedUser.selectedUserNames = selectedUserNamesArr.join(',');
                                    this.formData[this.field.formField] = this.selectedUser.selectedUserIds;
                                    this.formData[this.field.formField + '-user'] = this.selectedUser.selectedUserNames;
                                }
                            }
                        }
                    }
                } else {
                    let ext = this.field.options.ext2;
                    if (ext) {
                        let obj = JSON.parse(ext);
                        if (obj.showUserDetails === true || obj.showUserDetails === 'true') {
                            if (this.formData[this.field.formField] && this.formData[this.field.formField] !== '') {
                                let param = {userids: this.formData[this.field.formField]};
                                let res = await getUserExtendDataIds(param);
                                if (res && res.state === 'success') {
                                    let userList = res.userList;
                                    if (userList.length > 0) {
                                        let extendDataId = [];
                                        let userids = this.formData[this.field.formField].split(',');
                                        for (let i = 0; i < userids.length; i++) {
                                            let obj = userList.find(item => item.id === userids[i]);
                                            extendDataId.push(obj.extendDataId);
                                        }
                                        let extendDataIds = extendDataId.join(',');
                                        this.selectedUser.extendDataIds = extendDataIds;
                                        this.getDefaultUserFieldConfig(extendDataIds);
                                    }
                                }
                            }
                        }
                    }
                    this.selectedUser.selectedUserIds = this.formData[this.field.formField];
                    this.selectedUser.selectedUserNames = this.formData[this.field.formField + '-user'];
                }
                this.renderLinkField();
            } else if (this.field.type === 'process') {
                this.selectedProcess.selectedProcessIds = this.formData[this.field.formField];
                this.selectedProcess.selectedProcessNames = this.formData[this.field.formField + '-view'];
            } else if (this.field.type === 'text') {
                if (this.field.options.defaultValue !== '' && this.field.options.defaultValue !== undefined) {
                    if (isEmpty(this.formData[this.field.formField]) && this.field.options.defaultValue === '$PROCESSINSTANCE-NAME$') {
                        if (this.taskInstance && this.taskInstance.processInstanceName) {
                            this.formData[this.field.formField] = this.taskInstance.processInstanceName;
                        } else if (this.processInstance && this.processInstance.name) {
                            this.formData[this.field.formField] = this.processInstance.name;
                        }
                    } else if (isEmpty(this.formData[this.field.formField]) && this.field.options.defaultValue === '$TASKINSTANCE-NAME$') {
                        if (this.taskInstance && this.taskInstance.processInstanceName) {
                            this.formData[this.field.formField] = this.taskInstance.name;
                        }
                    } else if (!this.formData[this.field.formField] && this.field.options.defaultValue !== '$HYPERLINKS-NAME-READONLY$') {
                        this.formData[this.field.formField] = this.field.options.defaultValue;
                    }
                }
                if (this.isApproval && !this.isRead) {
                    this.approvalRemarksStyle = 'approvalRemarksStyle';
                    this.placeholderContent = '请输入审批意见';
                } else {
                    this.approvalRemarksStyle = '';
                    this.placeholderContent = '';
                }
                // 超链接属性
                if (this.field.options.ext1) {
                    this.ext1 = this.formData[this.field.formField + '-ext1'];
                }
                if (this.field.options.ext3 && this.field.options.ext3 === '1') {
                    this.editorbarVal = cloneDeep(this.formData[this.field.formField]);
                    setTimeout(() => {
                        if (this.$refs.editorbarRef) {
                            // 默认回显值
                            this.$refs.editorbarRef.setInitValue(this.editorbarVal);
                        }
                    }, 0);
                }
            } else if (this.field.type === 'subform') {
                if (!this.formData.hasOwnProperty('id')) {
                    // 假如没有值则进行初始化
                    if (this.field.options.defaultSetting !== '' && this.field.options.defaultSetting !== undefined) {
                        let defaultValues = JSON.parse(this.field.options.defaultSetting);
                        if (defaultValues && !Array.isArray(this.formData[this.field.id]) && isEmpty(this.formData[this.field.id])) {
                            let initArr = [];
                            defaultValues.forEach(ele => {
                                initArr.push(ele);
                            });
                            setTimeout(() => {
                                // 默认回显值
                                this.formData[this.field.id] = cloneDeep(initArr);
                            }, 500);
                        }
                    }
                }
                if (this.subformIsReadOuter) {
                    this.subformIsRead = true;
                } else {
                    this.subformIsRead = this.isRead;
                }
                if (!isEmpty(this.approvalUserList) && this.isBelongApproval && this.field.options.defaultValue === 'true') {
                    this.subformIsRead = true;
                    if (this.field.hasOwnProperty('addApprovalUserList') && this.field.addApprovalUserList) {
                        return;
                    }
                    for (var i = 0; i < this.approvalUserList.length; i++) {
                        let newApprovalerField = formBaseField.getTextField();
                        newApprovalerField.options.config.type = 'textarea';
                        newApprovalerField.id = this.approvalUserList[i].userId;
                        newApprovalerField.label = '(' + (i + 1) + '审)' + this.approvalUserList[i].trueName;
                        newApprovalerField.name = '(' + (i + 1) + '审)' + this.approvalUserList[i].trueName;
                        newApprovalerField.isRead = this.userInfo.userId !== this.approvalUserList[i].userId;
                        if (this.userInfo.userId === this.approvalUserList[i].userId) {
                            this.subformIsRead = false;
                        }
                        newApprovalerField.isApproval = true;
                        this.field.options.fieldList.push(newApprovalerField);
                    }
                    // 增加属性，用于防止重复增加审核人信息
                    this.field.addApprovalUserList = true;
                }
                // }
            } else if (this.field.type === 'address') {
                this.selectedOptions = this.formData[this.field.formField];
            } else if (this.field.type === 'select') {
                if (!this.formData.hasOwnProperty(this.field.formField + '-view')) {
                    this.formData[this.field.formField + '-view'] = '';
                }
                if (this.isAddFormField() && this.field.options.config.options && this.field.options.config.options.length > 0) {
                    // 下拉框默认值初始化;
                    this.field.options.config.options.forEach(op => {
                        if (op.def === true) {
                            if (!this.formField) {
                                this.formField = op.value;
                            }
                        }
                    });
                }
            } else if (this.field.type === 'category') {
                if (this.isAddFormField() && this.field.options.config.options && this.field.options.config.options.length > 0) {
                    // 选项默认值初始化
                    let categoryArr = [];
                    this.field.options.config.options.forEach(op => {
                        if (op.def === true) {
                            if (this.fieldSubType === 'single') { // radio
                                if (!this.formField) {
                                    this.formField = op.value;
                                }
                            } else if (this.fieldSubType === 'multi') { // checkbox
                                categoryArr.push(op.value);
                            }
                        }
                    });
                    if (this.fieldSubType === 'multi' && !this.formData.hasOwnProperty('isOldData') && categoryArr.length > 0) {
                        this.categoryMultiValue = categoryArr;
                    }
                }
            } else if (this.field.type === 'date') {
                let dateTimeValueformat2 = 'yyyy-MM-dd hh:mm:ss';
                if (this.fieldSubType === 'date') {
                    this.dateType = 'date';
                } else if (this.fieldSubType === 'dateTime') {
                    this.dateType = 'datetime';
                }
                if (this.fieldSubType === 'dateTime' && !isEmpty(this.field.options.ext3)) {
                    if (this.field.options.ext3 === '1') { // 时分
                        this.dateTimeValueformat = 'yyyy-MM-dd HH:mm';
                        dateTimeValueformat2 = 'yyyy-MM-dd hh:mm';
                    } else if (this.field.options.ext3 === '2') { // 时
                        this.dateTimeValueformat = 'yyyy-MM-dd HH';
                        dateTimeValueformat2 = 'yyyy-MM-dd hh';
                    }
                }
                if (this.fieldSubType === 'date' && !isEmpty(this.field.options.ext3)) {
                    if (this.field.options.ext3 === '1') { // 年月
                        this.dateValueformat = 'yyyy-MM';
                        this.dateType = 'month';
                    } else if (this.field.options.ext3 === '2') { // 年
                        this.dateValueformat = 'yyyy';
                        this.dateType = 'year';
                    }
                    // console.log(this.dateValueformat);
                }
                if (this.field.options.defaultValue === 'true' && isEmpty(this.formData[this.field.formField])) {
                    this.formData[this.field.formField] = formatDate(new Date(), (this.fieldSubType === 'dateTime' ? 'yyyy-MM-dd hh:mm:ss' : 'yyyy-MM-dd'));
                }
                if (this.field.options.lastDateView && this.isBelongApproval && isEmpty(this.formData[this.field.formField])) { // 只有审批表单模式下写默认值
                    this.formData[this.field.formField] = formatDate(new Date(), (this.fieldSubType === 'dateTime' ? dateTimeValueformat2 : this.dateValueformat));
                }
            } else if (this.field.type === 'calculation') {
                if (this.field.options.formulaExp !== undefined && ((this.field.options.formulaExp.indexOf(';') !== -1) || (this.field.options.formulaExp.indexOf(',') !== -1))) {
                    this.formData.formulaExp = 1;// 做需要跨表单计算的标识
                    if (this.field.options.defaultValue !== '' && this.field.options.defaultValue !== undefined && isEmpty(this.formData[this.field.formField]) && !this.formData.hasOwnProperty('id')) {
                        this.formData[this.field.formField] = Number(this.field.options.defaultValue);
                    }
                } else if (this.field.options.formulaExp !== undefined) {
                    let formulaExp = this.field.options.formulaExp;
                    if (this.fieldsList && Array.isArray(this.fieldsList)) {
                        for (var idx = 0; idx < this.fieldsList.length; idx++) {
                            let fieldObj = this.fieldsList[idx];
                            if (fieldObj.type === 'calculation' && fieldObj.options.formulaExp !== undefined && ((fieldObj.options.formulaExp.indexOf(';') !== -1) || (fieldObj.options.formulaExp.indexOf(',') !== -1))) { // 使用了子表单数据源
                                if (formulaExp.indexOf(fieldObj.id) !== -1) {
                                    this.isSaveCompute = true;
                                    break;
                                }
                            }
                        }
                    }
                    if ((formulaExp.indexOf(';') === -1) && (formulaExp.indexOf(',') === -1)) {
                        if (!this.field.subFormFieldId) { // 子表单内的字段初始化时暂时不进行重新计算逻辑了
                            await this.handleMainCalculation(this.field.id); // 假如有简单计算字段关联，根据数学公式进行计算，为了效率考虑暂时不支持跨表单字段
                        }
                    }
                }
                if (this.field.options.moneyFormat) { // 金额字段格式化配置
                    this.showMoneyText = true;
                }
            } else if (this.field.type === 'location') {

            } else if (this.field.type === 'number') {
                if (this.field.options.defaultValue !== '' && this.field.options.defaultValue !== undefined) {
                    this.setNumberAllowText();
                    if (!this.formData[this.field.formField] && this.numberType !== 'text') { // 设置数字类型默认值
                        if (this.formData.hasOwnProperty(this.field.formField)) { // 判断包含当前字段才进行赋值，假如是后加的字段，针对老的数据就不进行赋值
                            this.formData[this.field.formField] = this.field.options.defaultValue;
                        }
                    }
                }
                if (this.field.options.moneyFormat && this.numberType === 'number') { // 金额字段格式化配置
                    this.showMoneyText = true;
                }
            } else if (this.field.type === 'position') {
                let node = {};
                node.title = this.formData[this.field.formField + '-tree'];
                node.value = this.formData[this.field.formField];
                setTimeout(() => {
                    // 默认回显值
                    if (this.$refs.positionTreeChild) {
                        this.$refs.positionTreeChild._refreshSelectedNode(node);
                    }
                }, 0);
            }
        },
        setNumberAllowText () {
            if (this.field.options.defaultValue === '$NUMBER-TYPE-ALLOW_TEXT$') { // 支持输入字符
                this.numberType = 'text';
            }
        },
        async setUserExtCascadeData (initFlg) { // 初始化默认级联选择人员级联的字段赋值
            if (this.field && this.field.options) {
                let ext = this.field.options.ext2;
                if (ext) {
                    let obj = JSON.parse(ext);
                    if (obj.setDataRelation && obj.userFieldDataRelation) { // 获取要赋值的值
                        let userFieldDataRelation;
                        if (typeof (obj.userFieldDataRelation) === 'object') {
                            userFieldDataRelation = obj.userFieldDataRelation;
                        } else {
                            userFieldDataRelation = JSON.parse(obj.userFieldDataRelation);
                        }
                        if (this.formData[this.field.formField] && this.formData[this.field.formField] !== '') {
                            let param = {userids: this.formData[this.field.formField]};
                            let res = await getUserExtendDataIds(param);
                            if (res && res.state === 'success') {
                                let userList = res.userList;
                                if (userList.length > 0) {
                                    let extendDataId = [];
                                    let userids = this.formData[this.field.formField].split(',');
                                    for (let i = 0; i < userids.length; i++) {
                                        let obj = userList.find(item => item.id === userids[i]);
                                        extendDataId.push(obj.extendDataId);
                                    }
                                    let extendDataIds = extendDataId.join(',');
                                    let param = {extendDataIds: extendDataIds, userFieldDataRelation: userFieldDataRelation};
                                    await this.autoUserCompleteData(param, initFlg);
                                }
                            }
                        }
                    }
                }
            }
        },
        isAddFormField () {
            let res = false;
            if ((!this.isFromSubForm && (this.isBelongApproval ? objectKeyIsEmpty(this.formData) : !this.formData.id)) ||// 外层表单
                (this.isFromSubForm && (this.isBelongApproval ? objectKeyIsEmpty(this.formData) : !this.formData.subId))) { // 子表单通过外层formdata的Id
                res = true;
            }
            return res;
        },
        async showUserDetail (extendDataIds) {
            if (extendDataIds && extendDataIds !== '') {
                this.getDefaultUserFieldConfig(extendDataIds);
            } else {
                this.selectedUser.tableColumns = [];
                this.selectedUser.pageData = [];
            }
        },
        async handleTreeNode (data, node, tree) {
            if (this.field.type === 'serialNumber' && this.fieldSubType === 'multi') {
                // 流水号多选
                if (this.field.options.ext3 && this.field.options.ext3 > 1) {
                    this.field.options.config.options[0].value = data.id;
                } else {
                    this.setSerialNumber(data.id);
                }
                this.formData[this.field.formField + '-tree'] = data.label;
            } else if ((this.field.type === 'dictionary' || this.field.type === 'department') && this.fieldSubType === 'multi') {
                // 数据字典、部门多选
                this.formData[this.field.formField] = data.selectedIds;
                this.formData[this.field.formField + '-tree'] = data.selectedNames;
            } else {
                this.formData[this.field.formField] = data.id;
                this.formData[this.field.formField + '-tree'] = data.label;
                if (this.field.type === 'dictionary' && this.fieldSubType === 'single') { // 数据字典单选级联
                    if (this.fieldsList && Array.isArray(this.fieldsList)) {
                        this.fieldsList.forEach(fieldObj => {
                            if (fieldObj.options.synLinkField && this.field.id === fieldObj.options.synLinkField) {
                                this.formData[fieldObj.id] = data.remarks;// 默认使用字典树的备注值，后续再升级改造
                                this.$emit('refreshViewField');
                            }
                        });
                    }
                }
            }
            if (this.field.type === 'department') {
                let treeRoot = {
                    id: cloneDeep(this.formData[this.field.formField]),
                    label: cloneDeep(this.formData[this.field.formField + '-tree'])
                };
                if (this.fieldsList && Array.isArray(this.fieldsList)) {
                    this.fieldsList.forEach(fieldObj => {
                        if (fieldObj.type === 'department' && fieldObj.options.cascadeDeptField && this.field.id === fieldObj.options.cascadeDeptField) {
                            this.$emit('loadDeptField', treeRoot, fieldObj);
                        }
                    });
                }
                if (this.field.options.ext2) {
                    let ext2 = this.field.options.ext2;
                    if (ext2) {
                        let ext2Obj = JSON.parse(ext2);
                        if (ext2Obj.masterUserDeptFieldCheck) { // 配置了部门负责人赋值功能
                            let masterUserDeptField = ext2Obj.masterUserDeptField;
                            let res = this.fieldsList.find(cur => cur.id === masterUserDeptField);
                            let type = res.options.config.type;
                            if (type === 'single') { // 单选
                                if (data.deptMasterUserIds !== '') {
                                    this.formData[masterUserDeptField] = data.deptMasterUserIds.split(',')[0];
                                    this.formData[masterUserDeptField + '-user'] = data.deptMasterUserNames.split(',')[0];
                                }
                            } else { // 多选
                                this.formData[masterUserDeptField] = data.deptMasterUserIds;
                                this.formData[masterUserDeptField + '-user'] = data.deptMasterUserNames;
                            }
                        }
                        if (ext2Obj.automaticRecodeRefField) { // 配置了级联带出
                            let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                            let automaticRecodeFieldsArray = automaticRecodeFields.split(',');
                            for (let i = 0; i < automaticRecodeFieldsArray.length; i++) {
                                let automaticRecodeFieldsItem = automaticRecodeFieldsArray[i];
                                let fieldObj = this.fieldsList.find(element => element.id === automaticRecodeFieldsItem);
                                if (fieldObj) {
                                    await this.getTableFirstRefData(fieldObj, this.fieldsList);
                                }
                            }
                        }
                    }
                }
            }
        },
        initDeptField (treeRoot) {
            let isLoad = this.field.options.cascadeDeptField;
            if (treeRoot && isLoad) {
                this.$nextTick(_ => {
                    this.$refs.treeChild.refreshDataSource(treeRoot.id);
                });
            }
        },
        async resetSelectFieldOptions (options) {
            // console.log(options);
            try {
                if (options) {
                    this.field.options.config.options = options;
                    this.$emit('refreshViewField');
                    // if (options) {
                    //     options.forEach(item => {
                    //         this.$set(this.formData, this.field.formField, item.value);
                    //     });
                    // }
                    // this.$emit('refreshViewField');
                    // await saveConfigOptionList(options);
                }
            } catch (error) {
                console.error(error);
            }
        },
        async refreshFieldItemValue (value) {
            this.$set(this.formData, this.field.formField, value);
        },
        buildExt1 () {
            if (this.field.options.ext1 && this.field.options.defaultValue === '$HYPERLINKS-NAME-READONLY$') {
                this.formData[this.field.formField] = this.ext1;
            }
            this.formData[this.field.formField + '-ext1'] = this.ext1;
            if (!isEmpty(this.taskInstance)) {
                this.$emit('refreshViewField');
            }
        },
        async checkSerialNumberIfExist (formField) {
            if (formField !== '') {
                let data = await checkSerialNumberIfExist(formField);
                if (data && data.usedCnt > 0) {
                    this.messageTip('温馨提示：流水号【' + formField + '】已被使用', 'warning');
                }
            }
        },
        async setSerialNumber (sid) {
            if (this.field.options.defaultValue === 'processName' && (this.taskInstance || this.processInstance)) {
                if (this.taskInstance && this.taskInstance.processInstanceName) {
                    this.formData[this.field.formField] = this.taskInstance.processInstanceName;
                } else if (this.processInstance.name) {
                    this.formData[this.field.formField] = this.processInstance.name;
                }
            } else if (this.field.options.defaultValue === 'taskName' && this.taskInstance) {
                if (this.taskInstance.name) {
                    this.formData[this.field.formField] = this.taskInstance.name;
                }
            } else if (sid) {
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let ext2Obj = JSON.parse(ext2);
                    if (ext2Obj.seriaNumberFormFieldId || ext2Obj.seriaNumberSelectTypeFormFieldId || ext2Obj.seriaNumberBusinessTypeFormFieldId) {
                        this.$message.error('动态取值的流水号不支持手动获取和初始化获取');
                        return;
                    }
                }
                let numberObj = await getSerialNumber(sid);
                if (numberObj) {
                    this.formData[this.field.formField] = numberObj.newSerialNumber;
                    this.formData[this.field.formField + '-sn'] = numberObj.sn;
                }
            }
        },
        async reSetSerialNumber (fieldItem) {
            if (fieldItem.options.config.type === 'single') {
                this.reSetLoading = true;
                let val = fieldItem.options.config.options.length > 0 ? fieldItem.options.config.options[0].value : '';
                this.setSerialNumber(val);
                this.reSetLoading = false;
            } else {
                this.messageTip('目前仅支持单选模式下的重新获取', 'warning');
            }
        },
        chooseProcess () {
            this.isShowProcessPop = true;
            // setTimeout(() => {
            //     // 初始化
            //     if (this.$refs.processPop) {
            //         this.$refs.processPop._initPage();
            //     }
            // }, 0);
        },
        chooseUser () {
            this.$nextTick(function () {
                setTimeout(() => {
                // 初始化
                    if (this.$refs.userChild) {
                        this.$refs.userChild._initPage();
                    }
                }, 0);
                this.isShowUserOrg = true;
            });
        },
        activeStyle () {
            let single = {
                width: '96%',
                float: 'left'
            };
            if (!this.isPrintPage) {
                single.margin = '1px 0px 0px 0pxx';
            }
            // 子表单、分割线、单列显示时都去掉当前字段的margin、float样式，否则一行多列受影响
            if (this.field.type === 'subform' || this.field.type === 'archive' || this.field.type === 'divider' || this.field.type === 'subFormSummary' || this.field.options.unique) {
                single.width = this.isPrintPage ? '72%' : '100%';
                this.setHeightStyle(single);
            } else if (this.field.type === 'divider' || this.field.type === 'subFormSummary' || this.field.options.unique) {
                single.width = '96%';
                if (this.colSpan === 2) {
                    // 一行两列
                    if ((this.findex + 1) % 2 === 0) {
                        // single.margin = '1px 10px 2px 0px';
                    }
                }
                return single;
            } else {
                this.setHeightStyle(single);
                if (this.colSpan === 2) {
                    // 一行两列
                    single.width = '49%';
                    if ((this.findex + 1) % 2 === 0) {
                    }
                } else if (this.colSpan === 3) {
                    // 一行三列
                    single.width = '32%';
                }
            }
            return single;
        },
        setRadioStyle () {
            let single = {
                // 'background-color': 'rgba(253, 246, 236, 1)',
                // 'border-color': 'rgba(253, 246, 236, 1)',
                // color: 'black'
            };
            return single;
        },
        setHeightStyle (single) {
            if (this.field.name.length > 10) { // 默认高度
            } else {
                // if (this.field.type !== 'link' && this.fieldSubType !== 'multi' && this.field.type !== 'file') { // 防止多行多列对不上
                if (this.field.type === 'serialNumber') {
                    if (this.fieldSubType === 'multi') {
                        single.height = this.isPrintPage ? '70px' : '75px';
                    } else {
                        single.height = this.isPrintPage ? '32px' : '40px';
                    }
                } else if ((this.field.type === 'text' && this.fieldSubType === 'input') || (this.field.type === 'user' && this.field.options.config.type === 'single')) { // 防止多行多列对不上
                    single.height = this.isPrintPage ? '32px' : '40px';
                    // } else if (this.field.type !== 'text' && this.field.type !== 'link' && this.field.type !== 'file' && this.field.type !== 'category') { // 防止多行多列对不上
                } else if (this.field.type === 'category') { // 防止多行多列对不上
                    let contentArr = this.field.options.config.options;
                    if (!isEmpty(contentArr) && contentArr.length < 4) {
                        single.height = this.isPrintPage ? '32px' : '40px';
                    }
                    if (this.colSpan > 1) {
                        // single.height = this.isPrintPage ? '32px' : '40px';
                    }
                } else if (this.field.type !== 'text' && this.field.type !== 'file' && this.field.type !== 'link' && this.field.type !== 'subform' && this.field.type !== 'archive' && this.field.type !== 'category') { // 防止多行多列对不上
                    single.height = this.isPrintPage ? '32px' : '40px';
                }
            }
        },
        subFormActiveStyle () {
            let single = {
                width: 'auto'
            };
            if (this.isFromSubForm) {
                return single;
            } else {
                return {};
            }
        },
        async handleSaveOption (obj) {
            try {
                let resp = await saveConfigOption(obj);
                obj.id = resp.id;
            } catch (error) {
                console.error('handleSaveOption' + error);
            }
        },
        async handleSubFormSummary (formField) {
            // todo:利用配置好的数学表达式进行计算
            let summaryFormulaExp = formField.options.formulaExp; // 计算表达式
            if (summaryFormulaExp) {
                let formObj = this.formData;
                if (this.parentFormData) {
                    formObj = Object.assign(this.parentFormData, formObj);
                }
                let param = { formId: this.formId, fieldId: formField.id, summaryFormulaExp: summaryFormulaExp, formObj: formObj };
                try {
                    let resp = await saveSubFormSummary(param);
                    if (resp) {
                        resp.forEach(item => {
                            let key = Object.keys(item);
                            this.$set(this.formData, key, item[key]);
                            if (this.parentFormData) {
                                this.$set(this.parentFormData, key, item[key]);
                            }
                        });
                    }
                } catch (error) {
                    console.error('handleSubFormSummary' + error);
                }
                this.handleCalculation(); // 假如有计算字段关联，根据数学公式进行计算
            }
        },
        async handleCalculation () {
            // todo:利用配置好的数学表达式进行计算
            await this.handleMainCalculation();
            // this.formData[this.field.formField] = numberObj.newSerialNumber;
            // 更新显示金额大写的字段
            this.upMoneyField();
        },
        async handleMainCalculation (formulaId) {
            // todo:利用配置好的数学表达式进行计算
            if (this.field.relationFormulas || formulaId) {
                let formObj = this.formData;
                if (this.parentFormData) {
                    formObj = Object.assign(this.parentFormData, formObj);
                }
                let param = {};
                if (formulaId) {
                    param = { relationFormulas: formulaId, formObj: formObj };
                } else {
                    param = { relationFormulas: this.field.relationFormulas, formObj: formObj };
                }
                try {
                    let resp = await saveCalculation(param);
                    if (resp) {
                        if (this.field.type === 'number' && !isEmpty(this.field.options.formulaExp)) { // 数字类型且配置了公式的为配置了校验规则，此处略过校验规则的字段
                            // TODO：根据情况做扩展后补
                        } else {
                            for (let k = 0; k < resp.length; k++) {
                                let item = resp[k];
                                let key = Object.keys(item);
                                this.$set(this.formData, key, item[key]);
                                if (this.parentFormData) {
                                    this.$set(this.parentFormData, key, item[key]);
                                }
                            }
                        }
                        if (this.field.relationFormulas) {
                            let relationFormulasArr = this.field.relationFormulas.split(',');
                            let formulaExpFieldMap = new Map();
                            for (var m = 0; m < this.fieldsList.length; m++) {
                                let fieldObj = this.fieldsList[m];
                                if (fieldObj.type === 'calculation' && fieldObj.options.formulaExp !== undefined) {
                                    formulaExpFieldMap.set(fieldObj.id, fieldObj);
                                }
                            }
                            for (var idx = 0; idx < this.fieldsList.length; idx++) {
                                let fieldObj = this.fieldsList[idx];
                                if (fieldObj.type === 'calculation' && fieldObj.options.formulaExp !== undefined) {
                                    for (var j = 0; j < relationFormulasArr.length; j++) {
                                        if (fieldObj.options.formulaExp.indexOf(relationFormulasArr[j]) !== -1) { // 关联计算
                                            await this.handleMainCalculationExt(fieldObj.id, false, formulaExpFieldMap);
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error('handleCalculation' + error);
                }
            }
        },
        async handleMainCalculationExt (relationFormulas, repeat, formulaExpFieldMap) {
            // todo:利用配置好的数学表达式进行计算
            let formObj = this.formData;
            if (this.parentFormData) {
                formObj = Object.assign(this.parentFormData, formObj);
            }
            if (isEmpty(formulaExpFieldMap)) {
                formulaExpFieldMap = new Map();
                for (var m = 0; m < this.fieldsList.length; m++) {
                    let fieldObj = this.fieldsList[m];
                    if (fieldObj.type === 'calculation' && fieldObj.options.formulaExp !== undefined) {
                        formulaExpFieldMap.set(fieldObj.id, fieldObj);
                    }
                }
            }

            let param = { relationFormulas: relationFormulas, formObj: formObj };
            try {
                let resp = await saveCalculation(param);
                if (resp) {
                    for (let k = 0; k < resp.length; k++) {
                        let item = resp[k];
                        let key = Object.keys(item);
                        this.$set(this.formData, key, item[key]);
                        if (this.parentFormData) {
                            this.$set(this.parentFormData, key, item[key]);
                        }
                    }
                    if (repeat && this.fieldsList && Array.isArray(this.fieldsList)) {
                        let cascadedMap = new Map();
                        let relationFormulasArr = relationFormulas.split(',');
                        relationFormulasArr.forEach(item => {
                            cascadedMap.set(item, item);
                        });
                        for (let i = 0; i < this.fieldsList.length; i++) {
                            let fieldObj = this.fieldsList[i];
                            if (cascadedMap.has(fieldObj.id)) {
                                if (fieldObj.relationFormulas) {
                                    await this.handleMainCalculationExt(fieldObj.relationFormulas, true, formulaExpFieldMap);// 假如有计算字段关联，根据数学公式进行计算
                                } else {
                                    await this.handleMainCalculationExt(fieldObj.id, false, formulaExpFieldMap);// 假如有计算字段关联，根据数学公式进行计算
                                }
                            }
                        }
                    } else {
                        if (!isEmpty(formulaExpFieldMap)) {
                            for (let [id, formulaField] of formulaExpFieldMap.entries()) {
                                if (formulaField.options.formulaExp.indexOf(relationFormulas) !== -1) { // 关联计算
                                    await this.handleMainCalculationExt(id, false, formulaExpFieldMap);
                                }
                            };
                        }
                    }
                }
            } catch (error) {
                console.error('handleMainCalculationExt' + error);
            }
        },
        async upMoneyField () {
            // console.log(11111);
            // let formObj = cloneDeep(this.formData);
            let formObj = this.formData;
            if (this.parentFormData) {
                formObj = Object.assign(this.parentFormData, formObj);
            }
            let param = { fieldId: this.field.id, formObj: formObj };
            try {
                let resp = await getUpMoneyFieldList(param);
                if (resp) {
                    resp.forEach(item => {
                        let key = Object.keys(item);
                        this.$set(this.formData, key, item[key]);
                        if (this.parentFormData) {
                            this.$set(this.parentFormData, key, item[key]);
                        }
                    });
                }
            } catch (error) {
                console.error('handleCalculation' + error);
            }
        },
        upDynamicDateField () {
            // console.log(this.field);
            if (!isEmpty(this.fieldsList)) {
                this.fieldsList.forEach(element => {
                    if (element.type === 'date') {
                        if (element.options.ext2) {
                            let isChanged = false;
                            let ext2Obj = JSON.parse(element.options.ext2);
                            if (ext2Obj.isDynamicAssignmentDate && ext2Obj.dynamicAssignmentDateSourceFieldId === this.field.id) {
                                let currentVal = this.formData[element.id];
                                let dynamicAssignmentDateDay = ext2Obj.dynamicAssignmentDateDay;
                                let curVal = this.formData[this.field.id];
                                if (isEmpty(curVal)) {
                                    return;
                                }
                                if (!this.dateRelationSettingMap.has(this.field.id)) {
                                    this.dateRelationSettingMap.set(this.field.id, curVal);
                                } else {
                                    let oldVal = this.dateRelationSettingMap.get(this.field.id);
                                    if (curVal === oldVal) {
                                        isChanged = false;
                                    } else {
                                        isChanged = true;
                                        this.dateRelationSettingMap.set(this.field.id, curVal);
                                    }
                                }
                                if (!isEmpty(currentVal) && !isChanged) {
                                    return;
                                }
                                let startDate = new Date(Date.parse(curVal.replace(/-/g, '/')));
                                let h = startDate.getHours();
                                let m = startDate.getMinutes();
                                let s = startDate.getSeconds();
                                let res = this.jumpNumDay(startDate, dynamicAssignmentDateDay);
                                if (element.options.config.type === 'dateTime') {
                                    // res += ' ' + h + ':' + m + ':' + s;
                                    res += ' ';
                                    if (h) {
                                        let h2 = Number(h);
                                        res += h2 < 10 ? '0' + h2 : h2;
                                    } else {
                                        res += '00';
                                    }
                                    if (m) {
                                        let m2 = Number(m);
                                        res += ':' + (m2 < 10 ? '0' + m2 : m2);
                                    } else {
                                        res += ':' + '00';
                                    }
                                    if (s) {
                                        let s2 = Number(s);
                                        res += ':' + (s2 < 10 ? '0' + s2 : s2);
                                    } else {
                                        res += ':' + '00';
                                    }
                                }
                                this.formData[element.id] = res;
                            }
                        }
                    }
                });
            }
        },
        jumpNumDay (date, num, linkStr = '-') {
            date = new Date(date.getTime() + (num * 24 * 60 * 60 * 1000));
            return date.getFullYear() + linkStr + this.changeNum(date.getMonth() + 1) + linkStr + this.changeNum(date.getDate());
        },
        changeNum (num) {
            if (num >= 10) {
                return num;
            } else {
                return '0' + num;
            }
        },
        calculationBlur (formField) {
            if (this.field.relationFormulas) {
                this.handleCalculation(); // 假如有计算字段关联，根据数学公式进行计算
            }
            if (this.field.type === 'number' || this.field.type === 'calculation') {
                if (this.field.options.moneyFormat && this.numberType === 'number') {
                    this.showMoneyText = true;
                }
                // 更新显示金额大写的字段
                this.upMoneyField();
            }
        },
        calculationFocus (formField) {
            // if (this.field.relationFormulas) {
            //     this.handleCalculation();// 假如有计算字段关联，根据数学公式进行计算
            // }
        },
        moneyTextInputFocus () {
            this.showMoneyText = false;
        },
        messageTip (msg, type) {
            this.$message({
                message: msg,
                type: type,
                duration: 3000
            });
        },
        handleChangeData (value) {
            this.addr.address = value.join('/'); // 获取到城市地址
            this.$set(this.formData, this.field.formField, this.selectedOptions);
            this.formData[this.field.formField + '-view'] = this.addr.address;
        },
        handleCascaderData (value) {
            if (this.field.options.config.type === 'single') {
                this.formData[this.field.formField + '-view'] = this.$refs[this.field.formField].getCheckedNodes()[0].pathLabels.join('/');
                this.formData[this.field.formField + '-filtVal'] = this.$refs[this.field.formField].getCheckedNodes()[0].data.filtVal;
            } else if (this.field.options.config.type === 'multi') {
                if (value.length > 0) {
                    let viewArray = [];
                    let filtVal = 0;
                    this.$refs[this.field.formField].getCheckedNodes().forEach(node => {
                        if (this.arrayContainFunc(value, node.path)) {
                            viewArray.push(node.pathLabels.join('/'));
                            filtVal = filtVal | node.data.filtVal;
                        }
                    });
                    this.formData[this.field.formField + '-view'] = viewArray.join(',');
                    this.formData[this.field.formField + '-filtVal'] = filtVal;
                } else {
                    this.$set(this.formData, this.field.formField, '');
                    delete this.formData[this.field.formField + '-view'];
                    delete this.formData[this.field.formField + '-filtVal'];
                }
            }
        },
        arrayContainFunc (arr, cur) {
            let result = false;
            arr.map((e, i) => {
                if (JSON.stringify(e) === JSON.stringify(cur)) result = true;
            });
            return result;
        },
        loadLinkData (soureData) {
            this.$emit('dealSpecialField', this.field.id);
            if (this.fieldsList && Array.isArray(this.fieldsList)) {
                this.fieldsList.forEach(fieldObj => {
                    if (fieldObj.type === 'subform' && fieldObj.options.unique) { // 使用了子表单数据源
                        this.$emit('loadLinkData', soureData, fieldObj);
                    }
                });
            }
        },
        initAddLinkData (soureData) {
            if (this.field.options.formulaExp) {
                let sourceMainFieldId = this.field.options.formulaExp.split(',')[1];
                let sourceSubformFieldId = this.field.options.formulaExp.split(',')[2];
                let isLoad = this.field.options.unique;
                if (soureData && soureData.has(sourceMainFieldId) && isLoad) {
                    let soureObj = soureData.get(sourceMainFieldId)[sourceSubformFieldId];
                    if (soureObj && this.$refs.fieldSubformRef) {
                        this.$refs.fieldSubformRef.initAddLinkData(soureObj);
                    }
                }
            }
        },
        async handelSelectVal (key) {
            let ext2 = this.field.options.ext2;
            if (ext2) {
                let ext2Obj = JSON.parse(ext2);
                if (ext2Obj.automaticRecodeRefField) { // 配置了级联带出
                    let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                    let automaticRecodeFieldsArray = automaticRecodeFields.split(',');
                    for (let i = 0; i < automaticRecodeFieldsArray.length; i++) {
                        let automaticRecodeFieldsItem = automaticRecodeFieldsArray[i];
                        let fieldObj = this.fieldsList.find(element => element.id === automaticRecodeFieldsItem);
                        if (fieldObj) {
                            await this.getTableFirstRefData(fieldObj, this.fieldsList);
                        }
                    }
                }
            }
            if (!key) {
                return;
            }
            let obj = {};
            obj = this.field.options.config.options.find((item) => {
                return item.value === key;
            });
            if (obj && obj.assignmentFieldId && obj.assignmentFieldValue) {
                this.formData[obj.assignmentFieldId] = obj.assignmentFieldValue;
                if (this.fieldsList && Array.isArray(this.fieldsList)) {
                    for (let i = 0; i < this.fieldsList.length; i++) {
                        let fieldObj = this.fieldsList[i];
                        if (fieldObj.id === obj.assignmentFieldId) { // 检查级联字段是否参加计算
                            // console.log(fieldObj);
                            if (fieldObj.relationFormulas) {
                                await this.handleMainCalculationExt(fieldObj.relationFormulas, true);// 假如有计算字段关联，根据数学公式进行计算
                            }
                        }
                    }
                }
            }
            this.formData[this.field.formField] = key;
            this.formData[this.field.formField + '-view'] = key;
            this.formField = key;
            // 20231011 edit by hezhen 放开级联控制设置
            // if ((this.field.ext2 && this.field.ext2 === '1') || (obj && !obj.ext3)) { // 被选中作为级联组件，就不继续进行级联处理了
            //     return;
            // }
            let showFieldArray = [];
            let hidenFieldArray = [];
            let showFieldMap = new Map();
            let hidenFieldMap = new Map();
            for (let i = 0; i < this.field.options.config.options.length; i++) {
                let cur = this.field.options.config.options[i];
                if (cur && cur.ext3) {
                    if (cur.value == this.formData[this.field.id]) {
                        let extsIds = cur.ext3.split(',');
                        for (let j = 0; j < extsIds.length; j++) {
                            let id = extsIds[j];
                            if (!showFieldMap.has(id)) {
                                showFieldArray.push(id);
                                showFieldMap.set(id, true);
                            }
                        }
                    } else {
                        let extsIds = cur.ext3.split(',');
                        for (let j = 0; j < extsIds.length; j++) {
                            let id = extsIds[j];
                            if (!hidenFieldMap.has(id)) {
                                hidenFieldArray.push(id);
                                hidenFieldMap.set(id, false);
                            }
                        }
                    }
                }
            }
            this.isHidenField(hidenFieldArray, hidenFieldMap);
            this.isShowField(showFieldArray, showFieldMap, hidenFieldMap);
            // console.log(showFieldArray);
            // console.log(hidenFieldArray);
            // console.log(this.fieldsList);
        },
        async getTableFirstRefData (fieldObj, fieldsList) {
            let refTableData = [];
            let refTableColumn = [];
            this.searchParams.searchCondition = [];// 初始化搜索条件
            if (fieldObj.ext1 && this.searchParams.searchCondition.length === 0) { // 默认筛选值
                let obj = JSON.parse(fieldObj.ext1);
                this.defaultConditonsMap = new Map();
                for (let key in obj) {
                    obj[key]['modelId'] = fieldObj.options.config.form.modelId;
                    this.searchParams.searchCondition.push(obj[key]);
                    this.defaultConditonsMap.set(obj[key].id, obj[key]);
                }
                this.searchCondition = this.searchParams.searchCondition;
            }
            // 任务表单内选择关联数据，默认从前3000条数据中进行筛选。
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            await this.setDefaultConditionRef(fieldObj);
            let isStopSearch = false;
            for (let i = 0; i < this.searchParams.searchCondition.length; i++) {
                let defaultCondition = this.searchParams.searchCondition[i];
                if (defaultCondition.operateType === 7) { // 从表单字段值取值搜索
                    let searchvalue = this.formData[defaultCondition.valueFieldId];
                    let cur = fieldsList.find(element => element.id === defaultCondition.valueFieldId);
                    let searchvalueView = '';
                    if (cur) {
                        if (cur.type === 'category' || cur.type === 'select') {
                            searchvalueView = this.formData[defaultCondition.valueFieldId + '-view'];
                            let options = defaultCondition.options.config.options;
                            for (let i = 0; i < options.length; i++) {
                                let item = options[i];
                                if (item.title === searchvalueView) {
                                    searchvalue = item.value;
                                }
                            }
                        } else if (cur.type === 'department') {
                            searchvalue = this.formData[defaultCondition.valueFieldId + '-tree'];
                            searchvalueView = this.formData[defaultCondition.valueFieldId + '-tree'];
                        } else if (cur.type === 'user') {
                            searchvalue = this.formData[defaultCondition.valueFieldId + '-user'];
                            searchvalueView = this.formData[defaultCondition.valueFieldId];
                        } else if (cur.type === 'link') {
                            searchvalue = this.formData[defaultCondition.valueFieldId + '-link'];
                            searchvalueView = this.formData[defaultCondition.valueFieldId + '-view'];
                        }
                        if (searchvalue) {
                            defaultCondition.conditionValue = searchvalue;
                            defaultCondition.conditionValueView = searchvalueView;
                            defaultCondition.operateType = 1;
                        } else {
                            isStopSearch = true;
                            break;
                        }
                    }
                }
            }
            if (isStopSearch) {
                return;
            }
            // 处理关联字段值的搜索
            let formData = await getModelFormReportList({
                currentPage: 1,
                pageSize: 1,
                modelId: fieldObj.options.config.form.modelId,
                formId: fieldObj.options.config.form.formId,
                isRelationSearch: true,
                isFromFieldItemLink: true, // 是否进行关联字段的表单数据查询
                processInstanceId: this.processInstanceId,
                searchCondition: this.searchParams.searchCondition
            });
            if (formData.data) {
                let tableDatas = [];
                formData.data.forEach(item => {
                    let jsonObj = JSON.parse(item);
                    tableDatas.push(jsonObj);
                });
                refTableData = tableDatas;
                loading.close();
            }
            if (formData.otherData) {
                refTableColumn = formData.otherData.tableColumns;
            }
            //   this.loadTimer = new Date().getTime();
            if (fieldObj.options.config.form.selectTableHeaderFields) { // 配置了关联列表模型显示表头
                let cacheTableColumns = [];
                for (let i = 0; i < refTableColumn.length; i++) {
                    let cur = refTableColumn[i];
                    if (fieldObj.options.config.form.selectTableHeaderFields.indexOf(cur.id) !== -1) {
                        cacheTableColumns.push(cur);
                    }
                }
                refTableColumn = cacheTableColumns;
            }
            if (refTableData.length > 0) {
                let param = {row: refTableData[0]};
                this.handelSelectRefRow(param, fieldObj, refTableColumn);
            }
        },
        handelSelectRefRow (params, fieldObj, refTableColumn) { // TODO
            let selData = cloneDeep(params.row);
            let selectTableData = [selData];// 复制当前选中数据
            let linkData = this.setLinkTableData(refTableColumn, selectTableData[0]);
            let curFieldData = {
                modelId: fieldObj.options.config.form.modelId,
                tableColumns: refTableColumn,
                tableData: [linkData]
            };
            this.formData[fieldObj.id] = curFieldData;
            this.formData[fieldObj.id + '-link'] = linkData.id;
            // this.formData[fieldObj.id + '-view'] = linkData[refTableColumn[1].id];
            this.formData[fieldObj.id + '-view'] = linkData[refTableColumn[0].id];
            this.updSynLinkFieldData(selData, refTableColumn, fieldObj.id);
        },
        updSynLinkFieldData (sourceData, selectTableColumns, currentlinkFieldId) { // 配置了级联带出的字段进项赋值
            let targetFormFieldlist = this.fieldsList;
            selectTableColumns.forEach(fieldObj => {
                let sourceFieldLabel = fieldObj.label;
                targetFormFieldlist.forEach(element => {
                    if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                        if (element.options.synLinkFormFieldId) {
                            if (element.options.synLinkFormFieldId === fieldObj.id) {
                                this.updFieldData(element, fieldObj, sourceData);
                            }
                        } else {
                            if (sourceFieldLabel === element.name && element.type === 'text') {
                                this.updFieldData(element, fieldObj, sourceData);
                            }
                        }
                    }
                });
            });
        },
        // 修改配置了关联映射的字段值
        updFieldData (element, fieldObj, sourceData) {
            let type = fieldObj.type;
            let sourceValueKey = ''; // 对应userId等唯一性值
            let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
            let can = false; // 是否支持级联显示
            let sourceDepartmentValueKey = ''; // 对应部门等唯一性值
            if (type === 'dictionary' || type === 'businessTree' || type === 'department') { // -tree
                can = true;
                sourceDepartmentValueKey = sourceData[fieldObj.id];
                sourceValue = sourceData[fieldObj.id + '-tree'];
            } else if (type === 'user') { // -user
                can = true;
                sourceValueKey = sourceData[fieldObj.id];
                sourceValue = sourceData[fieldObj.id + '-user'];
            } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                // -view
                can = true;
                sourceValue = sourceData[fieldObj.id + '-view'];
                if (element.options.synLinkFormField && element.options.synLinkFormField.type && element.options.synLinkFormField.type === 'category' && element.options.synLinkFormField.options.config.type === 'multi') {
                    let cacheValue = sourceData[fieldObj.id];
                    let cacheValueArray = [];
                    for (let i = 0; i < fieldObj.otherSetting.colorOne.length; i++) {
                        let cur = fieldObj.otherSetting.colorOne[i];
                        if (cacheValue.indexOf(cur.value) !== -1) {
                            cacheValueArray.push(cur.title);
                        }
                    }
                    sourceValue = cacheValueArray.join(',');
                }
            } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                can = true;
                sourceValue = sourceData[fieldObj.id];
            } else if (type === 'link') {
                can = true;
                sourceValue = sourceData[fieldObj.id + '-view'];
            } else if (type === 'subform') {
                can = true;
                sourceValue = sourceData[fieldObj.id];
            }
            if (can) {
                if (element.type === 'text') {
                    this.formData[element.id] = sourceValue;
                    this.formData[element.id + '-view'] = '';
                } else if (element.type === 'number' || element.type === 'calculation') {
                    if (!isEmpty(sourceValue)) {
                        this.formData[element.id] = sourceValue;
                        this.formData[element.id + '-view'] = '';
                    } else {
                        this.formData[element.id] = '';
                        this.formData[element.id + '-view'] = '';
                    }
                    this.refreshViewField();
                } else if (element.type === 'user') {
                    if (!isEmpty(sourceValue)) {
                        this.formData[element.id] = sourceValueKey;
                        this.formData[element.id + '-user'] = sourceValue;
                    } else {
                        this.formData[element.id] = '';
                        this.formData[element.id + '-user'] = '';
                    }
                    this.refreshViewField();
                } else if (element.type === 'department') {
                    if (!isEmpty(sourceValue)) {
                        this.formData[element.id] = sourceDepartmentValueKey;
                        this.formData[element.id + '-tree'] = sourceValue;
                    } else {
                        this.formData[element.id] = '';
                        this.formData[element.id + '-tree'] = '';
                    }
                    this.refreshViewField();
                } else if (element.type === 'select') {
                    if (!isEmpty(sourceValue)) {
                        // 下拉选项值
                        let targetFieldValue = {};
                        let targetFieldOptions = element.options.config.options;
                        for (let i = 0; i < targetFieldOptions.length; i++) {
                            let optionItem = targetFieldOptions[i];
                            if (optionItem.title === sourceValue) {
                                targetFieldValue = optionItem;
                                break;
                            }
                        }
                        if (targetFieldValue) {
                            this.formData[element.id] = targetFieldValue.value;
                            this.formData[element.id + '-view'] = targetFieldValue.title;
                        }
                        let formInfo = this.formInfo.formObj.structure[0];
                        if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                            this.loadTimerField = new Date().getTime();
                            for (var i = 0; i < formInfo.fieldsList.length; i++) {
                                let tempField = formInfo.fieldsList[i];
                                let tempRefName = 'fieldItemChild' + i;
                                if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                                    if (tempField.id === element.id) {
                                        setTimeout(() => {
                                            // 设置下拉字段级联默认显示数据
                                            if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                                this.$refs[tempRefName][0].setCascadeData();
                                            }
                                        }, 0);
                                    }
                                }
                            }
                        }
                    } else {
                        this.formData[element.id] = '';
                        this.formData[element.id + '-view'] = '';
                    }
                } else if (element.type === 'subform') {
                    let sourceSubColumns = fieldObj.subColumns;
                    let taragetSubColumns = element.options.fieldList;
                    let newValue = [];
                    if (!isEmpty(sourceValue)) {
                        for (let i = 0; i < sourceValue.length; i++) {
                            let sourceItemValue = sourceValue[i];
                            let targetItemValue = {};
                            for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                let targetColumn = taragetSubColumns[j];
                                for (let k = 0; k < sourceSubColumns.length; k++) {
                                    let sourceColumn = sourceSubColumns[k];
                                    if (targetColumn.label === sourceColumn.label) {
                                        if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                            // -tree
                                            targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                        } else if (sourceColumn.type === 'user') {
                                            // -user
                                            targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                        } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                            // -view
                                            targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                            if (element.options.synLinkFormField.type === 'category' && element.options.synLinkFormField.options.config.type === 'multi') {
                                                let cacheValue = sourceData[fieldObj.id];
                                                let cacheValueArray = [];
                                                for (let i = 0; i < fieldObj.otherSetting.colorOne.length; i++) {
                                                    let cur = fieldObj.otherSetting.colorOne[i];
                                                    if (cacheValue.indexOf(cur.value) !== -1) {
                                                        cacheValueArray.push(cur.title);
                                                    }
                                                }
                                                targetItemValue[targetColumn.id] = cacheValueArray.join(',');
                                            }
                                        } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                            targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                        }
                                        break;
                                    }
                                }
                            }
                            if (!isEmpty(targetItemValue)) {
                                newValue.push(targetItemValue);
                            }
                        }
                        this.formData[element.id] = newValue;
                    } else {
                        this.formData[element.id] = '';
                    }
                }
            }
        },
        setLinkTableData (selectTableColumns, sourceFormObj) { // 增加关联字段显示字段的冗余字段数据
            let linkData = {};
            if (sourceFormObj) {
                linkData['id'] = sourceFormObj.id;
                if (selectTableColumns && selectTableColumns.length > 0) {
                    let selectcolumns = cloneDeep(selectTableColumns);
                    // console.log(selectcolumns);
                    selectcolumns.forEach(item => {
                        if (item.type === 'dictionary' || item.type === 'businessTree' || item.type === 'department') {
                            // -tree
                            linkData[item.id] = sourceFormObj[item.id];
                            linkData[item.id + '-tree'] = sourceFormObj[item.id + '-tree'];
                        } else if (item.type === 'user') {
                            // -user
                            linkData[item.id] = sourceFormObj[item.id];
                            linkData[item.id + '-user'] = sourceFormObj[item.id + '-user'];
                        } else if (item.type === 'category' || item.type === 'select' || item.type === 'file' || item.type === 'process' || item.type === 'address' || item.type === 'cascader' || item.type === 'role') {
                            // -view
                            linkData[item.id] = sourceFormObj[item.id];
                            linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                        } else if (item.type === 'calculation' || item.type === 'number' || item.type === 'text' || item.type === 'serialNumber' || item.type === 'date') {
                            linkData[item.id] = sourceFormObj[item.id];
                        } else if (item.type === 'link') {
                            linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                        } else if (item.type === 'subform') {
                            linkData[item.id] = sourceFormObj[item.id];
                        }
                    });
                }
            }
            return linkData;
        },
        async setDefaultConditionRef (fieldObj) {
            if (fieldObj.options.ext3 && fieldObj.options.ext3 === '1' && !isEmpty(this.defaultConditonsMap)) { // 设置过滤条件为固定模式
                if (this.searchParams.searchCondition && Array.isArray(this.searchParams.searchCondition)) {
                    let defaultConditons = [];
                    this.searchParams.searchCondition.forEach(conditiontObj => {
                        if (this.defaultConditonsMap.has(conditiontObj.id)) {
                            let defaultCondition = this.defaultConditonsMap.get(conditiontObj.id);
                            if (defaultCondition && defaultCondition.conditionValue) {
                                defaultConditons.push(defaultCondition);
                            } else {
                                defaultConditons.push(conditiontObj);
                            }
                        } else {
                            defaultConditons.push(conditiontObj);
                        }
                    });
                    if (!isEmpty(defaultConditons)) {
                        this.searchParams.searchCondition = defaultConditons;
                    }
                }
            }
            if (fieldObj.options.ext2) {
                let def = JSON.parse(fieldObj.options.ext2);
                if (def.linkConfig) {
                    let linkConfig = JSON.parse(def.linkConfig);
                    if (linkConfig.linkConfigState) { // 需要过滤数据
                        this.searchParams.searchCondition = [];
                        let key = linkConfig.id + '-link';
                        let value = this.formData[key];
                        let curObj = JSON.parse(linkConfig.linkFieldObj);
                        curObj.conditionValue = value;
                        curObj.operateType = 2;
                        this.searchParams.searchCondition.push(curObj);
                    }
                }
            }
            await this.setLinkLimitDataRef(fieldObj);
        },
        async setLinkLimitDataRef (fieldObj) {
            if (fieldObj.options.ext2) { // 子表单的值进行约束，例如只能查看自己作为项目成员参与的项目列表
                let json = JSON.parse(fieldObj.options.ext2);
                if (json.limitData === true && json.limitFieldDataArray && json.limitFieldDataArray.length > 0) {
                    let relateFormId = fieldObj.options.config.form.formId; // 关联字段的关联表单id
                    let formData = await getFormConfig(relateFormId);
                    if (formData) {
                        let fieldsList = formData.fieldsList;
                        if (fieldsList && fieldsList.length > 0) {
                            let conditonsMap = new Map();
                            for (let i = 0; i < json.limitFieldDataArray.length; i++) {
                                let limitField = json.limitFieldDataArray[i];
                                if (limitField.subFormFieldId) {
                                    let linkPropFieldId = limitField.linkPropFieldId;// 子表单字段
                                    let subFormFieldId = limitField.subFormFieldId;
                                    conditonsMap.set(linkPropFieldId, linkPropFieldId + ',' + subFormFieldId);
                                }
                            }
                            for (let k = 0; k < fieldsList.length; k++) {
                                let curfield = fieldsList[k];
                                if (curfield.type === 'subform' && conditonsMap.has(curfield.id)) {
                                    let targetStr = conditonsMap.get(curfield.id);
                                    curfield.filterMainFieldId = targetStr.split(',')[0];
                                    curfield.filterSubField = targetStr.split(',')[1];
                                    this.searchParams.searchCondition.push(curfield);
                                }
                            }
                        }
                    }
                }
            }
        },
        isHidenField (fieldArray, hidenFieldMap) {
            if (fieldArray.length > 0) {
                // let formReadOnlyMap = null;
                // console.log(this.taskInstance.formObj.formFieldsReadOnlyMap);// 只读字段
                // if (this.taskInstance && this.taskInstance.formObj && this.taskInstance.formObj.hasOwnProperty('formFieldsReadOnlyMap')) {
                //     formReadOnlyMap = this.taskInstance.formObj.formFieldsViewMap.get(this.formId);// 只读字段
                // }
                this.fieldsList.forEach(item => {
                    for (let i = 0; i < fieldArray.length; i++) {
                        let cur = fieldArray[i];
                        if (item.id === cur) {
                            item.isView = false;
                            this.formData[item.id + '-casDefautShow'] = false;
                            hidenFieldMap.delete(cur);
                        }
                    }
                });
            }
        },
        isShowField (fieldArray, showFieldMap, hidenFieldMap) {
            if (fieldArray.length > 0) {
                let formViewMap = null;
                // console.log(this.taskInstance.formObj.formFieldsViewMap);// 查看字段
                if (this.taskInstance && this.taskInstance.formObj && this.taskInstance.formObj.hasOwnProperty('formFieldsViewMap')) {
                    formViewMap = this.taskInstance.formObj.formFieldsViewMap[this.formId];// 查看字段
                }
                // console.log(formViewMap);// 查看字段
                for (let i = 0; i < fieldArray.length; i++) {
                    let cur = fieldArray[i];
                    this.fieldsList.forEach(item => {
                        // console.log(formViewMap[cur]);// 查看字段
                        if (item.id === cur && (!formViewMap || (formViewMap && formViewMap[cur]))) {
                            item.isView = true;
                            this.formData[item.id + '-casDefautShow'] = true;
                            showFieldMap.delete(cur);
                        }
                    });
                }
                let relateModel = new Map();
                hidenFieldMap.forEach(function (value, key) {
                    relateModel.set(key, value);
                });
                showFieldMap.forEach(function (value, key) {
                    relateModel.set(key, value);
                });
                this.$emit('refreshViewField', relateModel);
            }
        },
        initDefaultCasData () { // 设置下拉字段级联默认显示数据
            if (this.isAddFormField() && this.field.options.config.options && this.field.options.config.options.length > 0) {
                // 下拉框默认值初始化;
                this.field.options.config.options.forEach(op => {
                    if (op.def === true) {
                        if (this.field.type === 'select') {
                            this.handelSelectVal(op.value);
                        } else if (this.field.type === 'category') {
                            this.handelRadioVal(op.value);
                        }
                    }
                });
            }
            if (!this.isAddFormField() && this.field.options.config.options && this.field.options.config.options.length > 0) {
                // 设置导入的数据的级联显示字段
                this.field.options.config.options.forEach(op => {
                    // 1、默认值；2、任务发起审批流的情况
                    // if (op.def === true || this.isBelongApproval) {
                    let value = this.formData[this.field.id];
                    // console.log(this.field);
                    if (this.field.type === 'select') {
                        this.handelSelectVal(value);
                    } else if (this.field.type === 'category') {
                        this.handelRadioVal(value);
                    }
                    // }
                });
            }
            // 下拉字段，关联数据源重置
            this.updModeRefreshFieldOption();
        },
        setCascadeData () { // 设置下拉字段级联联动数据
            if (this.field.options.config.options && this.field.options.config.options.length > 0) {
                // 设置导入的数据的级联显示字段
                this.field.options.config.options.forEach(op => {
                    // 1、默认值；2、任务发起审批流的情况
                    // if (op.def === true || this.isBelongApproval) {
                    let value = this.formData[this.field.id];
                    // console.log(this.field);
                    if (this.field.type === 'select') {
                        this.handelSelectVal(value);
                    } else if (this.field.type === 'category') {
                        this.handelRadioVal(value);
                    }
                    // }
                });
            }
        },
        // 编辑模式下，重置设置了关联数据源属性的下拉字段选项值
        async updModeRefreshFieldOption () {
            // console.log(111);
            // 关联字段数据源，编辑状态处理
            if (!this.isAddFormField()) {
                if (this.field.type === 'select') {
                    if (this.field.options.dataSourceFieldId) {
                        // console.log(this.field.options.dataSourceFieldId);
                        let linkDataId = this.formData[this.field.options.dataSourceFieldId + '-link'];
                        if (!isEmpty(linkDataId)) {
                            let linkDataInfo = await getModelFormInstanceById(linkDataId);
                            let allFormFieldList = linkDataInfo.formObj.structure[0].fieldsList;
                            let linkDataValue = JSON.parse(linkDataInfo.formObj.instance);
                            let sourceData = linkDataValue.values;
                            allFormFieldList.forEach(fieldObj => {
                                if (fieldObj.type === 'subform') {
                                    // console.log(fieldObj);
                                    if (this.field.options.dataSourceSubFieldId === fieldObj.id) {
                                        this.reSetSelectOptions(this.field, fieldObj, sourceData);
                                    }
                                }
                            });
                        }
                    }
                }
            }
        },
        reSetSelectOptions (element, fieldObj, sourceData) {
            let type = fieldObj.type;
            let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
            if (type === 'subform') {
                sourceValue = sourceData[fieldObj.id];
                if (element.type === 'select') {
                    let sourceSubColumns = fieldObj.subColumns;
                    if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
                        sourceSubColumns = fieldObj.options.fieldList;
                        for (let k = 0; k < sourceSubColumns.length; k++) {
                            sourceSubColumns[k].label = sourceSubColumns[k].name;
                        }
                    }
                    let newOptions = [];
                    if (!isEmpty(sourceValue)) {
                        for (let i = 0; i < sourceValue.length; i++) {
                            let sourceItemValue = sourceValue[i];
                            let targetItemValue = {
                                id: '',
                                title: '',
                                value: '',
                                def: false,
                                optionConfigId: element.options.config.id,
                                formId: element.formId
                            };
                            // console.log(sourceItemValue);
                            for (let k = 0; k < sourceSubColumns.length; k++) {
                                let sourceColumn = sourceSubColumns[k];
                                if (element.name === sourceColumn.label) {
                                    if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                        // -tree
                                        targetItemValue.title = sourceItemValue[sourceColumn.id + '-tree'];
                                        targetItemValue.label = sourceItemValue[sourceColumn.id + '-tree'];
                                        targetItemValue.value = sourceItemValue[sourceColumn.id + '-tree'];
                                    } else if (sourceColumn.type === 'user') {
                                        // -user
                                        targetItemValue.title = sourceItemValue[sourceColumn.id + '-user'];
                                        targetItemValue.label = sourceItemValue[sourceColumn.id + '-user'];
                                        targetItemValue.value = sourceItemValue[sourceColumn.id + '-user'];
                                    } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                        // -view
                                        targetItemValue.title = sourceItemValue[sourceColumn.id + '-view'];
                                        targetItemValue.label = sourceItemValue[sourceColumn.id + '-view'];
                                        targetItemValue.value = sourceItemValue[sourceColumn.id + '-view'];
                                    } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                        targetItemValue.title = sourceItemValue[sourceColumn.id];
                                        targetItemValue.label = sourceItemValue[sourceColumn.id];
                                        targetItemValue.value = sourceItemValue[sourceColumn.id];
                                    }
                                    break;
                                }
                            }
                            if (!isEmpty(targetItemValue)) {
                                newOptions.push(targetItemValue);
                            }
                        }
                    }
                    this.resetSelectFieldOptions(newOptions);
                }
            }
        },
        handelRadioVal (key) {
            this.handelSelectVal(key);
            this.$emit('dealSpecialField', this.field.id);// 必填项回调校验去掉红色边框
        },
        showMapsChoose (obj) {
            this.locationInfo = obj;
            this.locationValue = this.formData[this.field.formField + '-view'];
            this.mapsInfo = obj;
            // this.active = true;
            this.isChooseMap = true;
        },
        async showCalculationDetail (obj, mainFormField) { // 20210906: 查看计算字段对应表单详情列表
            if (mainFormField) {
                // console.log(mainFormField.options.synLinkField);
                // console.log(mainFormField.options.synLinkFormFieldId);
                this.currentMainFormInfo.mainFormDataId = this.parentFormDataArr[0].values[mainFormField.options.synLinkField + '-link'];
                this.currentMainFormInfo.mainFormId = obj.formId;
                this.refModelTitle = '【' + mainFormField.name + '：' + this.formData[mainFormField.formField] + '】 对应的引用表单明细数据';
                // console.log(this.formData);
            } else {
                // console.log(this.formData);
                this.refModelTitle = '【' + obj.name + '：' + this.formData[obj.formField] + '】 对应的引用表单明细数据';
                this.currentMainFormInfo = {mainFormDataId: '', mainFormId: ''};
            }
            // console.log(this.currentMainFormInfo);

            let formulArr = [];
            this.explainFormula(obj.options.formulaView, formulArr);
            let formIdArr = [];
            for (let i = 0; i < formulArr.length; i++) {
                let currentIds = formulArr[i].split(',');
                // console.log(currentIds);
                if (currentIds) {
                    if (Array.isArray(currentIds)) {
                        let otherFormId = currentIds[0];// 目标表单id
                        // let otherKeyFieldId = currentIds[1];// 当前选择目标表单内统计的字段id(计数时与otherRefFieldId一致)
                        // let otherRefFieldId = currentIds[2];// 目标表单关联字段id
                        formIdArr.push(otherFormId);
                    } else {
                        formIdArr.push(currentIds);
                    }
                }
            }
            // console.log(formIdArr);
            // 用于关联计算的其他表的formId
            let formIds = formIdArr.join(',');
            // console.log(formIds);
            await this.initModelListByRefFormIds(formIds);
        },

        explainFormula (formula, formulArr) { // 遍历公式编辑器，设计出最后的公式
            if (formula.indexOf('<input') !== -1) {
                let startIdx = formula.indexOf('<input');
                let endIdx = formula.indexOf('>');
                let inputData = formula.substring(startIdx, endIdx + 1);
                startIdx = inputData.indexOf('flg=') + 5;
                endIdx = startIdx + 1;
                let type = inputData.substring(startIdx, endIdx);
                let idLen = 0;
                if (type === '3') { // // 跨表单字段，xxx,xxx,xxx,cnt 第一个是表单id,第二个是目标表单内统计的字段id(计数时与refFieldId一致)，第三个是目标表单与当前表单的关联字段id,第四个是计算公式（cnt:计数 sum:求和 avg:平均）
                    idLen = 102;
                } else if (type === '2') { // 跨表单字段，xxx;xxx;xxx 第一个是当前表单内关联字段id,第二个是被关联表单内选择计算的字段id,第三个是被关联表单id
                    idLen = 98;
                } else if (type === '1') { // 已有的元素
                    idLen = 32;
                } else { // 新增的元素
                    idLen = 16;
                }
                startIdx = inputData.indexOf('id=') + 4;
                endIdx = startIdx + idLen;
                let id = inputData.substring(startIdx, endIdx);
                formulArr.push(id);
                formula = formula.replace(inputData, id);
                formula = this.explainFormula(formula, formulArr);
            }
            return formula;
        },

        async initModelListByRefFormIds (formIds) {
            if (formIds) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let modelList = await getModelListByRefFormIds(formIds);
                this.refModelList = modelList;
                if (this.refModelList && this.refModelList.length > 0) {
                    // console.log(this.formInfo);
                    this.showRelateFormDialog = true;
                    this.showRelateFormTab = true;
                    // 默认打开第一个关联表单数据
                    this.relateFormTabName = this.refModelList[0].id;
                    this.renderModelFormList(this.refModelList[0]);
                } else {
                    this.showRelateFormDialog = false;
                    this.showRelateFormTab = false;
                }
                loading.close();
            }
        },

        handleRelateFormTabClick (tab, event) {
            // console.log(tab.name);
            this.relateFormTabName = tab.name;
            for (var i = 0; i < this.refModelList.length; i++) {
                let model = this.refModelList[i];
                if (model.id === this.relateFormTabName) {
                    this.renderModelFormList(model);
                }
            }
        },

        async renderModelFormList (model) {
            if (this.currentMainFormInfo.mainFormDataId) {
                model.mainFormId = this.currentMainFormInfo.mainFormId;
                model.mainFormDataId = this.currentMainFormInfo.mainFormDataId;
            } else {
                if (this.parentFormInfo) {
                    // console.log(this.mainInstanceId);
                    // 主表的formid
                    model.mainFormId = this.parentFormInfo.formId;
                    // 主表当前数据id
                    if (this.parentFormInfo.modelType === 7 && this.formData) { // edit by hezhen  20230724 使用员工列表的modelinstance主键
                        model.mainFormDataId = this.formData.id;
                    } else {
                        model.mainFormDataId = this.mainInstanceId;
                    }
                } else {
                    model.mainFormId = this.formId;
                    model.mainFormDataId = this.formData.id;
                }
                // console.log(model);
            }
            if (model.mainFormDataId) {
                this.loadTimerRelate = new Date().getTime();
                model.calculateFieldId = this.field.id;
                setTimeout(() => {
                    // 调用子组件的方法
                    // console.log(this.$refs['refModelList' + model.id]);
                    if (this.$refs['refModelList' + model.id]) {
                        this.$refs['refModelList' + model.id][0].renderFormList(model);
                    }
                }, 0);
            }
        },
        chooseMaps (obj, value) {
            this.locationInfo = obj;
            this.locationValue = this.formData[this.field.formField + '-view'];
            this.isChooseMap = true;
        },
        configLocationArray () {

        },
        hideSidebox () {

        },
        saveLocationInfo (obj) {
            this.formData[this.field.formField + '-view'] = JSON.stringify(obj);
            this.formData[this.field.formField] = obj.nearestPOI + '(' + obj.latitude + ',' + obj.longitude + ')';
            this.isChooseMap = false;
        },
        cancelLocationInfo () {
            this.isChooseMap = false;
        },
        asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId, isRefresh) {
            this.$emit('asynMainFormData', sourceData, selectTableColumns, currentlinkFieldId, this.formIndex);
            if (isRefresh) {
                this.$emit('refreshTaskDetail');
            }
        },
        refreshViewField () {
            this.$emit('refreshViewField');
        },
        async getDefaultUserFieldConfig (extendDataIds) {
            this.loading = true;
            let param = {};
            param.modelTypes = '7';
            let formData = await getModelServiceList(
                Object.assign(
                    {
                        currentPage: 0,
                        pageSize: 10
                    },
                    param
                )
            );
            if (formData.data.length > 0) {
                this.userExtendConfig = formData.data[0];
                this.showDetailList(extendDataIds);
            }
            this.loading = false;
        },
        async showDetailList (extendDataIds) {
            let param = {};
            param.formId = this.userExtendConfig.formId;
            param.modelId = this.userExtendConfig.id;
            param.employeeRequest = true;
            param.moreIds = extendDataIds;
            param.page = JSON.stringify(this.page);
            param.isFilterDuplicateData = false;
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: 1,
                pageSize: 100000
            }, param));
            if (formData.data) {
                let tableDatas = [];
                formData.data.forEach(item => {
                    let jsonObj = JSON.parse(item);
                    tableDatas.push(jsonObj);
                });
                this.selectedUser.pageData = tableDatas;
            }
            if (formData.otherData.tableColumns) {
                this.selectedUser.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                this.allTableColumns = cloneDeep(_tableColumns);
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider' && item.label !== '密码') { // 隐藏分割线
                        this.selectedUser.tableColumns.push(item);
                    }
                });
                this.timer = new Date().getTime();
            }
        },
        getOptionsData (obj) {
            let ext2 = obj.options.ext2;
            if (ext2) {
                let ext = JSON.parse(ext2);
                if (ext.addressLevel && ext.addressLevel === '1') {
                    return option;
                } else {
                    return options;
                }
            }
        },
        async autoUserCompleteData (obj, initFlg) {
            let param = {};
            param.modelTypes = '7';
            let formData = await getModelServiceList(
                Object.assign(
                    {
                        currentPage: 0,
                        pageSize: 10
                    },
                    param
                )
            );
            let objArr = [];
            if (formData.data) {
                objArr = formData.data;
            }
            if (objArr.length > 0) {
                this.userExtendConfig = objArr[0];
                let param = {};
                param.formId = this.userExtendConfig.formId;
                param.modelId = this.userExtendConfig.id;
                param.moreIds = obj.extendDataIds;
                param.page = JSON.stringify(this.page);
                param.isFilterDuplicateData = false;
                param.employeeRequest = true;
                let res = await getModelFormReportList(Object.assign({}, {
                    currentPage: 1,
                    pageSize: 100000
                }, param));
                if (res.data) {
                    let tableDatas = [];
                    res.data.forEach(item => {
                        if (typeof (item) === 'string') {
                            item = JSON.parse(item);
                        }
                        tableDatas.push(item);
                    });
                    let table = tableDatas[0];
                    let userFieldDataRelation = obj.userFieldDataRelation;
                    for (let i = 0; i < userFieldDataRelation.length; i++) {
                        let cur = userFieldDataRelation[i];
                        // 获取值并判空处理
                        let userFieldValue = '';
                        if (table[cur.userFieldId]) {
                            userFieldValue = table[cur.userFieldId];
                        }
                        let userFieldTreeValue = '';
                        if (table[cur.userFieldId + '-tree']) {
                            userFieldTreeValue = table[cur.userFieldId + '-tree'];
                        }
                        let userFieldViewValue = '';
                        if (table[cur.userFieldId + '-view']) {
                            userFieldViewValue = table[cur.userFieldId + '-view'];
                        }
                        let departmentValue = '';
                        if (table[cur.userFieldId + '-tree']) {
                            departmentValue = table[cur.userFieldId + '-tree'];
                        }

                        if (cur.userFieldObj && cur.userFieldObj.type === 'department') {
                            let obj = this.fieldsList.find(element => element.id === cur.formFieldObj.id);
                            if (obj && obj.options && obj.options.ext2) {
                                let ext2 = obj.options.ext2;
                                if (ext2) {
                                    let ext2Obj = JSON.parse(ext2);
                                    if (ext2Obj && ext2Obj.masterUserDeptFieldCheck) { // 配置了负责人赋值
                                        let masterUserDeptField = ext2Obj.masterUserDeptField;
                                        let res = this.fieldsList.find(cur => cur.id === masterUserDeptField);
                                        let data = await getDepartmentDetail(userFieldValue);
                                        let type = res.options.config.type;
                                        if (type === 'single') { // 单选
                                            if (data.deptMasterUserIds !== '') {
                                                this.formData[masterUserDeptField] = data.deptMasterUserIds.split(',')[0];
                                                this.formData[masterUserDeptField + '-user'] = data.deptMasterUserNames.split(',')[0];
                                            }
                                        } else { // 多选
                                            this.formData[masterUserDeptField] = data.deptMasterUserIds;
                                            this.formData[masterUserDeptField + '-user'] = data.deptMasterUserNames;
                                        }
                                    }
                                }
                            }
                            this.formData[cur.formFieldId] = userFieldValue;
                            if (cur.formFieldFilter) {
                                if (departmentValue.indexOf(cur.formFieldFilter) != -1) {
                                    this.formData[cur.formFieldId + '-tree'] = departmentValue;
                                }
                            } else {
                                this.formData[cur.formFieldId + '-tree'] = departmentValue;
                            }
                            if (!initFlg) {
                                if (cur.formFieldFilter) {
                                    if (departmentValue.indexOf(cur.formFieldFilter) != -1) {
                                        if (this.reqSouce === 1) {
                                            this.$emit('autoUserCompleteData', cur.formFieldId, userFieldValue);
                                            this.$emit('autoUserCompleteData', cur.formFieldId + '-tree', departmentValue);
                                        } else {
                                            this.$emit('asynFormUserFieldData', cur.formFieldId, userFieldValue);
                                            this.$emit('asynFormUserFieldData', cur.formFieldId + '-tree', departmentValue);
                                        }
                                    } else {
                                        if (this.reqSouce === 1) {
                                            this.$emit('autoUserCompleteData', cur.formFieldId, '');
                                            this.$emit('autoUserCompleteData', cur.formFieldId + '-tree', '');
                                        } else {
                                            this.$emit('asynFormUserFieldData', cur.formFieldId, '');
                                            this.$emit('asynFormUserFieldData', cur.formFieldId + '-tree', '');
                                        }
                                    }
                                } else {
                                    if (this.reqSouce === 1) {
                                        this.$emit('autoUserCompleteData', cur.formFieldId, userFieldValue, this.formIndex);
                                        this.$emit('autoUserCompleteData', cur.formFieldId + '-tree', departmentValue, this.formIndex);
                                    } else {
                                        this.$emit('asynFormUserFieldData', cur.formFieldId, userFieldValue, this.formIndex);
                                        this.$emit('asynFormUserFieldData', cur.formFieldId + '-tree', departmentValue, this.formIndex);
                                    }
                                }
                                this.loadTimer = new Date().getTime();
                            }
                        } else if (cur.userFieldObj && (cur.userFieldObj.type === 'select' || cur.userFieldObj.type === 'category')) {
                            if (!initFlg) {
                                if (cur.userFieldObj.type === 'select' || cur.userFieldObj.options.config.type === 'single') {
                                    let field = this.fieldsList.find(element => element.id === cur.formFieldId);
                                    if (field) {
                                        let options = field.options.config.options;
                                        if (options && options.length > 0) {
                                            let curopt = options.find(obj => obj.title === userFieldViewValue);
                                            if (curopt) {
                                                this.formData[cur.formFieldId] = curopt.value;
                                                this.formData[cur.formFieldId + '-view'] = curopt.title;
                                                if (this.reqSouce == 1) {
                                                    this.$emit('autoUserCompleteData', cur.formFieldId, userFieldViewValue);
                                                } else {
                                                    this.$emit('asynFormUserFieldData', cur.formFieldId, userFieldViewValue);
                                                }
                                            } else {
                                                this.formData[cur.formFieldId] = '';
                                                this.formData[cur.formFieldId + '-view'] = '';
                                            }
                                        }
                                    }
                                }
                                this.loadTimer = new Date().getTime();
                            }
                        } else if (cur.userFieldObj && cur.userFieldObj.type === 'position') {
                            if (!initFlg) {
                                this.formData[cur.formFieldId] = userFieldTreeValue;
                                if (this.reqSouce == 1) {
                                    this.$emit('autoUserCompleteData', cur.formFieldId, userFieldTreeValue);
                                } else {
                                    this.$emit('asynFormUserFieldData', cur.formFieldId, userFieldTreeValue);
                                }
                                this.loadTimer = new Date().getTime();
                            }
                        } else {
                            this.formData[cur.formFieldId] = userFieldValue;
                            if (!initFlg) {
                                if (this.reqSouce === 1) {
                                    this.$emit('autoUserCompleteData', cur.formFieldId, userFieldViewValue);
                                } else {
                                    this.$emit('asynFormUserFieldData', cur.formFieldId, userFieldValue);
                                }
                            }
                        }
                    }
                    if (initFlg) {
                        this.$emit('refreshViewField');
                    }
                }
            }
            // this.renderLinkField();
        },
        async renderLinkField () {
            let ext2 = this.field.options.ext2;
            if (ext2) {
                let ext2Obj = JSON.parse(ext2);
                if (ext2Obj.automaticRecodeRefField) { // 配置了级联带出
                    let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                    let automaticRecodeFieldsArray = automaticRecodeFields.split(',');
                    for (let i = 0; i < automaticRecodeFieldsArray.length; i++) {
                        let automaticRecodeFieldsItem = automaticRecodeFieldsArray[i];
                        let fieldObj = this.fieldsList.find(element => element.id === automaticRecodeFieldsItem);
                        if (fieldObj) {
                            await this.getTableFirstRefData(fieldObj, this.fieldsList);
                        }
                    }
                }
            }
        },
        isReadOnly (o, secondFlg) { // secondFlg 用来辅助超链接只读模式
            let flag = false;
            if (o.subFormFieldId && this.fieldsList) { // 说明是子表单
                // 找出主表单的配置
                let res = this.fieldsList.find(item => item.id == o.subFormFieldId);
                if (res.options.ext2) {
                    let obj = JSON.parse(res.options.ext2);
                    if (obj.fieldReadOnly && obj.fieldReadOnly == true) {
                        flag = true;
                    }
                }
            }
            if (o.options.ext1 && o.options.defaultValue === '$HYPERLINKS-NAME-READONLY$' && !secondFlg) { // 超链接字段设置当前模式时名称内部部分只读
                return true;
            }

            if (!this.formData.key && this.isFromSubForm && flag) {
                return false;
            } else {
                if (o.options.ext2) {
                    let obj = JSON.parse(o.options.ext2);
                    if (obj.fieldReadOnly == undefined) { // 没有设置过允许填写
                        return false;
                    } else {
                        if (this.isFromSubForm) {
                            return false;
                        } else {
                            if (obj.fieldReadOnly == true) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else {
                    return false;
                }
            }
        },
        numberValidate (event) {
            return (/[\d.-]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8;
        },
        async querySearchAsync (queryStr, cb) {
            // var restaurants = [
            //     {'value': '三全鲜食（北新泾店）'},
            //     {'value': 'Hot honey 首尔炸鸡（仙霞路）'}];
            // let restaurants = [];
            var restaurants = [];
            let formData = await getSingleFieldDataList({queryStr: queryStr, fieldId: this.field.formField, formId: this.formId, modelId: this.formConfig.modelId});
            if (formData) {
                restaurants = formData;
                cb(restaurants);
            }
        },
        handleTextSelect (selectObj) {
            let ext2 = this.field.options.ext2;
            if (ext2) {
                let ext2Obj = JSON.parse(ext2);
                let cascadeShowField = ext2Obj.cascadeShowField;
                if (cascadeShowField) { // 配置了级联显示
                    for (let i = 0; i < cascadeShowField.length; i++) {
                        let cur = cascadeShowField[i];
                        let values = JSON.parse(selectObj.formValues);
                        let val = values[cur];
                        let fieldsList = this.formConfig.fieldsList;
                        fieldsList.forEach(element => {
                            if (element.id === cur) {
                                if (element.type === 'text' || element.type === 'date' || element.type === 'number' || element.type === 'archive' || element.type === 'subform') {
                                    this.formData[cur] = val;
                                } else if (element.type === 'category' || element.type === 'file' || element.type === 'select' || element.type === 'address' || element.type === 'location') {
                                    let valView = values[cur + '-view'];
                                    this.formData[cur] = val;
                                    this.formData[cur + '-view'] = valView;
                                } else if (element.type === 'dictionary' || element.type === 'businessTree' || element.type === 'businessTree') {
                                    let valView = values[cur + '-tree'];
                                    this.formData[cur] = val;
                                    this.formData[cur + '-tree'] = valView;
                                } else if (element.type === 'serialNumber') {
                                    let valView = values[cur + '-sn'];
                                    this.formData[cur] = val;
                                    this.formData[cur + '-sn'] = valView;
                                } else if (element.type === 'user') {
                                    let valView = values[cur + '-user'];
                                    let userExtendInfo = values[cur + '-userExtendInfo'];
                                    this.formData[cur] = val;
                                    this.formData[cur + '-user'] = valView;
                                    this.formData[cur + '-userExtendInfo'] = userExtendInfo;
                                } else if (element.type === 'cascader') {
                                    let valView = values[cur + '-view'];
                                    let filtVal = values[cur + '-filtVal'];
                                    this.formData[cur] = val;
                                    this.formData[cur + '-view'] = valView;
                                    this.formData[cur + '-filtVal'] = filtVal;
                                } else if (element.type === 'link') {
                                    let valView = values[cur + '-view'];
                                    let link = values[cur + '-link'];
                                    this.formData[cur] = val;
                                    this.formData[cur + '-view'] = valView;
                                    this.formData[cur + '-link'] = link;
                                }
                            }
                        });
                    }
                }
            }
        },
        getProgressStatus () {
            let status;
            if (this.field.type === 'number' && this.field.options.isProgress) {
                if (this.formData[this.field.options.progressDateField]) {
                    let targetTime = this.formData[this.field.options.progressDateField];
                    let targetTimeObj = this.fieldsList.find(item => item.id === this.field.options.progressDateField);
                    if (Array.isArray(targetTime)) {
                        targetTime = targetTime[1];// 取截止时间
                    }
                    let progressData = this.formData[this.field.formField];// 当前进度值
                    progressData = progressData ? parseInt(progressData) : 0;
                    let progressTime = new Date(targetTime).getTime();
                    let currentTime = new Date().getTime();
                    this.progressContent = '输入进度值，不能超过100。进度比较规则：系统当前时间与日期字段【' + targetTimeObj.name + '】相比';
                    if (progressData === 100) { // 当前时间等于目标时间，且进度等于100
                        status = 'success';
                    } else if (progressTime < currentTime && progressData < 100) { // 当前时间 大于 截止目标时间，且进度小于100
                        status = 'exception';
                    }
                    return status;
                }
            }
            return status;
        },
        async seeProcessDetail () {
            if (isEmpty(this.selectedProcess.selectedProcessIds)) {
                return;
            }
            // 1.判断查看所有流程
            let res = this.viewTaskAuth();
            if (!res) { // 没有查看全部流程的权限
                let res = await getProcessInstancesUsers({processInstanceId: this.selectedProcess.selectedProcessIds});
                if (!res.isHashCurUser) {
                    this.$message.error('你没有参与此流程并且没有查看权限');
                } else {
                    this.showProcessDetail(this.selectedProcess.selectedProcessIds);
                }
            } else {
                this.showProcessDetail(this.selectedProcess.selectedProcessIds);
            }
        },
        async showProcessDetail (processInstanceId) {
            this.isShowDetail = false;
            this.loadProcessTimer = new Date().getTime();
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.instancesInfo = await getProcessInstancesDetail(processInstanceId);
            if (this.instancesInfo) {
                this.isShowDetail = true;
                this.isShowProcessInstanceDetail = true;
            } else {
                // 流程不存在或者已删除
                this.$message.error('该流程查询不到或已被删除！');
            }
            loading.close();
        },
        viewTaskAuth () {
            let isEditAuth = false;
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                let resources = currentUserInfo.resources;
                if (resources) {
                    for (let i = 0; i < resources.length; i++) {
                        if (resources[i].resourceUrl === 'AllProcessInstanceData') { // 是否可以查看所有流程(同时也包括查看非自己负责的所有任务)
                            isEditAuth = true;
                            break;
                        }
                    }
                }
            }
            return isEditAuth;
        },
        fieldFocus (tempRefKey) {
            if (this.$refs[tempRefKey]) {
                this.$refs[tempRefKey].focus();
            }
        },
        dealFileData (field) {
            this.$emit('dealSpecialField', field.id);
        },
        selectProcessTrigger (selected) { // 选择流程
            this.isShowProcessPop = false;
        }
    }
};
</script>

<style lang="less">
.render-form-item {
    .item-textarea {
        // border: 1px solid red;
        width: 100%;
        .el-form-item__content {
            // width: 100%;
        }
        .el-input {
            // width: auto;
        }
    }
    .el-form-item--small .el-form-item__content,
    .el-form-item--small .el-form-item__label {
        line-height: 32px;
        margin-bottom: 5px;
    }
    .el-form-item--small .el-form-item__error { // 为了界面显示效果，暂时隐藏必填项提示内容
      padding-top: 0px;
      display:none;
    }
    // .el-input--small .el-input__inner {
    //     margin-top: 6px;
    // }

    .field-des {
        // margin-top: 5px;
        margin-top: 1px;
        padding-left: 5px;
    }
    .print-page-label {
        margin-right: 15px;
    }
    .el-radio {
        color: #606266;
        cursor: pointer;
        margin-right: 20px;
    }
    .el-checkbox {
        color: #606266;
        font-weight: 500;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        margin-right: 20px;
    }
    .el-table .cell,
    .el-table th div{
      padding-left: 5px;
      padding-right: 0px;
    }
    .el-form--inline .el-form-item{
      margin-right: 0px;
    }
    // .el-input__inner {
    //   padding: 0px 25px;
    // }
    // .el-textarea__inner {
    //   padding: 5px 25px;
    // }

      .relateFormTab {
          .el-tabs__header {
              margin: 0 0 2px;
          }
      }

      .richtext-content {
            display: -webkit-flex;  
            -webkit-justify-content: center;  
            -webkit-align-items: center; 
            table {
              border:none;
              border-collapse:collapse;
            }
            table td,
            table th{
              border: 1px solid #ccc;
              padding: 3px 5px;
              min-width: 50px;
              height: 20px;
            }
            table th {
              border-right: 1px solid #ccc;
              border-bottom: 2px solid #ccc;
              text-align: center;
              background-color: #f1f1f1;
            }
            blockquote{
              display: block;
              border-left: 8px solid #d0e5f2;
              padding: 5px 10px;
              margin: 10px 0;
              line-height: 1.4;
              font-size: 100%;
              background-color: #f1f1f1;
            }
            code{
              display: inline-block;
              *display: inline;
              *zoom: 1;
              background-color: #f1f1f1;
              border-radius: 3px;
              padding: 3px 5px;
              margin: 0 3px;    
            }
            pre code {
              display: block;
            }
            ul, ol{
              margin: 10px 0 10px 20px;
            }
            pre {
              border: 1px solid #ccc;
              background-color: #f8f8f8;
              padding: 10px;
              margin: 5px 0px;
              font-size: 0.8em;
              border-radius: 3px;
            }
            .ql-editor ul li {
                list-style-type: disc;    // 解决序列li前面的.不展示问题
            }
            .ql-editor ol li {
                list-style-type: decimal;   // 解决序列li前面的数字不展示问题
            }
        }
}
.user-item-detail{
    height: auto !important;
    min-height: 40px;
}
.form-required {
    color: red;
}
.numberUnit {
    border: 1px solid #dcdfe6;
    // border-left: none;
    // overflow: hidden;
    display: block;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // max-width: 105px;
    padding: 0 10px;
    // height: 30px;
    line-height: 30px;
    // border-right: none;
    background: #f2f6fc;
    font-style: normal;
    box-sizing: border-box;
    border-radius: 4px;
    // margin-top: 6px;
    margin-top: 1px;
    .numberUnit2 {
        border-right: none;
    }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type='number'] {
    -moz-appearance: textfield;
}

.approvalRemarksStyle {
    .el-textarea__inner {
        // background-color: #ecf5ff;
        // border-color: #b3d8ff;
        background-color: #f0f9eb;
        border-color: #c2e7b0;
    }
}
.field-tips{
    max-width: 70vw;
    max-height: 200px;
    overflow: auto;
}
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    content: "*";
    color: #cd0000;
    margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/FieldItem/FieldItem.vue